"use client";
import { useEffect, useState, useRef } from "react";
import mapboxgl from "mapbox-gl";
import MapboxGeocoder from "@mapbox/mapbox-gl-geocoder"; // Import Mapbox Geocoder
import "@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css"; // Import Geocoder CSS
import * as turf from "@turf/turf";

import { Chart, CategoryScale, LinearScale } from "chart.js/auto"; // Import Chart.js and required scales
// import Slider from '@mui/material/Slider';
// import Typography from '@mui/material/Typography';
import {
  Slider,
  Typography,
  Button,
  Switch,
  FormControlLabel,
} from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import CompareArrowsIcon from "@mui/icons-material/CompareArrows";
import ReactSlider from "react-slider";
import ButtonFilter from "./ButtonFilter"; // Import the child component
import PopupChart from "./PopupChart"; // Import the child component
import Header from "./Header"; // Import the child component
import ConfirmModal from "./ConfirmModal"; // Import the child component
import { useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import { jwtDecode } from "jwt-decode";
import FilterListIcon from "@mui/icons-material/FilterList"; // You can use any icon
import Modal from "react-modal";
import { List, AutoSizer } from "react-virtualized";
import "react-virtualized/styles.css";
// mapboxgl.accessToken = 'your_mapbox_token_here';
mapboxgl.accessToken =
  "pk.eyJ1IjoiYWJoaWppdGgxMjc5IiwiYSI6ImNtNGNqdzE4NDA2MGoyaXFwdXh6cjVqMWQifQ.OpRKi-Zt3NIOjXFz-hd-DA";

// Register the required scales
Chart.register(CategoryScale, LinearScale);

const CircleFilter = () => {
  // const eula_accepted = localStorage.getItem('eula_accepted') === 'true';
  const [map, setMap] = useState(null);
  const [roiFilter, setRoiFilter] = useState("All"); // State for ROI filter
  const [appreciationFilter, setAppreciationFilter] = useState("All"); // State for Appreciation filter
  const [scoreFilter, setScoreFilter] = useState("All"); // State for Score filter

  // State to track visibility of each filter's ButtonGroup
  const [showROIFilter, setShowROIFilter] = useState(false);
  const [showAppreciationFilter, setShowAppreciationFilter] = useState(false);
  const [showScoreFilter, setShowScoreFilter] = useState(false);
  const [showPriceFilter, setShowPriceFilter] = useState(false);
  const [sliderMinSales, setSliderMinSales] = useState(null); // Default to 0
  const [sliderMaxSales, setSliderMaxSales] = useState(null); // Default to 0
  const [activeMetric, setActiveMetric] = useState("roi");

  const [popupData, setPopupData] = useState(null);
  const [propertyList, setPropertyList] = useState([]);
  const [originalPropertyList, setOriginalPropertyList] = useState([]); // Store original (unfiltered) property list
  const [styleLoaded, setStyleLoaded] = useState(false); // Flag to track style load status
  const [isFullWidth, setIsFullWidth] = useState(false);
  const [searchPincode, setSearchPincode] = useState(""); // State for search input

  const [metricControl, setMetricControl] = useState(null);
  const geocoderContainerRef = useRef(null);

  const [currentPopup, setCurrentPopup] = useState(null);

  const [minSales, setMinSales] = useState(null); // Default to 0
  const [maxSales, setMaxSales] = useState(null); // Default to 0
  const [checkedItems, setCheckedItems] = useState({});

  const [popupInstance, setPopupInstance] = useState(null); // Default to 0

  const navigate = useNavigate();
  const authToken = localStorage.getItem("authToken"); // Retrieve the auth token from localStorage
  const [isMenuOpen, setIsMenuOpen] = useState(false); // State to manage menu visibility
  const [isCompareClicked, setIsCompareClicked] = useState(false); // State to manage compare option visibility
  const popupRef = useRef(null);
  const customPopupRef = useRef(null);
  const [activeTab, setActiveTab] = useState("all"); // State to manage which tab is active ('all' or 'favorites')
  let isFavorite = false; // Flag to track the favorite status
  const [isLoading, setIsLoading] = useState(false);
  const [forceRerender, setForceRerender] = useState(false);
  const [sortKey, setSortKey] = useState("roi"); // default sort by roi
  const [sortOrder, setSortOrder] = useState("desc"); // ascending order
  const [currentStateId, setCurrentStateId] = useState(null);
  const [currentCity, setCurrentCity] = useState(null);
  const [popupHTML, setPopupHTML] = useState(""); // for detailed popup
  const [currentView, setCurrentView] = useState("split"); // default is split view
  const [isSubscribed, setIsSubscribed] = useState(
    localStorage.getItem("isSubscribed") === "true"
  );
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [zipToRemove, setZipToRemove] = useState(null);
  const [selectedZipcode, setSelectedZipcode] = useState(null);
  const [compareList, setCompareList] = useState([]);
  const mapRef = useRef(null);
  const [showMobileFilters, setShowMobileFilters] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const [showEulaModal, setShowEulaModal] = useState(false);
  const [htmlContent, setHtmlContent] = useState("");
  const [canAccept, setCanAccept] = useState(false);
  const scrollRef = useRef(null);
  const ROW_HEIGHT = 45; 

  const activeFilterCount = [
    roiFilter !== "All",
    appreciationFilter !== "All",
    scoreFilter !== "All",
    minSales !== sliderMinSales,
    maxSales !== sliderMaxSales,
  ].filter(Boolean).length;
  //  const userAgent = window.navigator.userAgent.toLowerCase();
  //  const isMobile = /android|iphone|ipad|ipod/i.test(userAgent);
  //  if(isMobile){
  //    setCurrentView('list');
  //  }
  // useEffect(() => {
  //   // If there is no authToken, redirect the user to SignIn page
  //   if (!authToken) {
  //     navigate('/');
  //   }
  // }, [authToken, navigate]);

  //  useEffect(() => {
  //     const handleCopyPaste = (e) => {
  //       e.preventDefault();
  //     };

  //     document.addEventListener('copy', handleCopyPaste);
  //     document.addEventListener('cut', handleCopyPaste);
  //     document.addEventListener('paste', handleCopyPaste);
  //     document.addEventListener('contextmenu', handleCopyPaste); // right-click
  //     document.addEventListener('keydown', (e) => {
  //       // Disable Ctrl+C, Ctrl+V, Ctrl+X
  //       if ((e.ctrlKey || e.metaKey) && ['c', 'v', 'x'].includes(e.key.toLowerCase())) {
  //         e.preventDefault();
  //       }
  //     });

  //     return () => {
  //       document.removeEventListener('copy', handleCopyPaste);
  //       document.removeEventListener('cut', handleCopyPaste);
  //       document.removeEventListener('paste', handleCopyPaste);
  //       document.removeEventListener('contextmenu', handleCopyPaste);
  //     };
  //   }, []);

  const [showPdfModal, setShowPdfModal] = useState(false);

  useEffect(() => {
    const accepted = localStorage.getItem("eula_accepted") == "true"; // Check if EULA is accepted
    console.log("EULA Accepted:", accepted);
    console.log(localStorage.getItem("eula_accepted"));
    if (!accepted) {
      //   setShowPdfModal(true);
      setShowEulaModal(true);
    }
  }, []);

  // Load EULA HTML from assets
  useEffect(() => {
    fetch("/assets/eula.html")
      .then((res) => res.text())
      .then((data) => setHtmlContent(data))
      .catch((err) => console.error("Error loading EULA:", err));
  }, []);

  const handleScroll = () => {
    if (scrollRef.current) {
      const { scrollTop, scrollHeight, clientHeight } = scrollRef.current;
      if (scrollTop + clientHeight >= scrollHeight - 5) {
        setCanAccept(true);
      }
    }
  };

  useEffect(() => {
    const checkTokenValidity = () => {
      if (!authToken) {
        navigate("/");
        return;
      }

      try {
        const decoded = jwtDecode(authToken);

        const isExpired = decoded.exp * 1000 < Date.now();

        if (isExpired) {
          // Optional: clear storage
          localStorage.removeItem("authToken");
          localStorage.removeItem("refreshToken");
          localStorage.removeItem("email");
          localStorage.removeItem("isSubscribed");

          navigate("/");
        }
      } catch (e) {
        // If token is malformed or can't be decoded
        localStorage.removeItem("authToken");
        navigate("/");
      }
    };

    checkTokenValidity();
  }, [authToken, navigate]);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen); // Toggle the menu visibility
  };
  // Format Date to display with suffix (st, nd, rd, th)
  const formatDate = (date) => {
    const options = {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
      timeZone: "Asia/Kolkata",
    };

    const day = date.getDate();
    const suffix = ["st", "nd", "rd", "th"][((day % 10) - 1 + 4) % 4];
    const formattedDate = new Intl.DateTimeFormat("en-GB", options).format(
      date
    );
    return formattedDate.replace(/\d{1,2}/, (match) => match + suffix);
  };

  // ROI and Appreciation color ranges
  const roiColors = {
    roi: [
      { color: "#acacac", label: "0" },
      { color: "#FFE36B", label: "5" },
      { color: "#FFB36B", label: "10" },
      { color: "#FE5C5C", label: "15" },
      { color: "#F26BFF", label: "20" },
      { color: "#CE1E50", label: "25" },
    ],
    appreciation: [
      { color: "#acacac", label: "All" },
      { color: "#FFE36B", label: "0" },
      { color: "#FFB36B", label: "5" },
      { color: "#FE5C5C", label: "10" },
      { color: "#F26BFF", label: "15" },
      { color: "#CE1E50", label: "20" },
    ],
    score: [
      { color: "#acacac", label: "0" },
      { color: "#FFE36B", label: "7" },
      { color: "#FFB36B", label: "10" },
      { color: "#FE5C5C", label: "15" },
      { color: "#F26BFF", label: "20" },
      { color: "#CE1E50", label: "25" },
    ],
  };

  const handleAgree = async () => {
    //  setShowPdfModal(false)
    setShowEulaModal(false);

    try {
      const response = await fetch(
        "https://beta.flowlogic.com/api/users/accept-eula/",
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`, // usually expected
          },
          body: JSON.stringify({ eula_accepted: true }), // send as boolean
        }
      );

      const data = await response.json().catch(() => ({})); // handle empty JSON

      if (!response.ok) {
        console.error("Accept EULA failed:", data);
        throw new Error(`Request failed with status ${response.status}`);
      }

      console.log("EULA API Response:", data);

      if (data.message === "EULA accepted successfully") {
        localStorage.setItem("eula_accepted", "true");
        // setShowPdfModal(false);
        setShowEulaModal(false);
      }
    } catch (error) {
      console.error("Error accepting EULA:", error);
    }
  };

  // Function to toggle the metric
  const toggleMetric = () => {
    console.log("Access Token:", "${authToken}");
    let newMetric;

    if (activeMetric === "roi") {
      newMetric = "appreciation";
    } else if (activeMetric === "appreciation") {
      newMetric = "score";
    } else {
      newMetric = "roi";
    }

    setActiveMetric(newMetric); // Update the active metric
  };

  class MetricToggleButton {
    constructor(setActiveMetric, activeMetric) {
      this.container = document.createElement("div");
      this.container.className = "mapboxgl-ctrl mapboxgl-ctrl-top";

      // Styling for the container
      Object.assign(this.container.style, {
        position: "absolute",
        top: "10px",
        left: "50%",
        transform: "translateX(-50%)", // Center horizontally
        zIndex: "10",
        backgroundColor: "#00000061",
        padding: "5px 10px",
        borderRadius: "30px",
        display: "flex",
        gap: "10px",
        boxShadow: "0 2px 5px rgba(0,0,0,0.3)", // Adds a slight shadow
        fontSize: "12px",
      });

      // ROI Button
      this.roiButton = document.createElement("button");
      this.roiButton.textContent = "ROI";
      this.roiButton.onclick = () => setActiveMetric("roi");
      this.styleButton(this.roiButton, activeMetric === "roi");

      // Appreciation Button
      this.appreciationButton = document.createElement("button");
      this.appreciationButton.textContent = "Appreciation";
      this.appreciationButton.onclick = () => setActiveMetric("appreciation");
      this.styleButton(
        this.appreciationButton,
        activeMetric === "appreciation"
      );

      // Score Button
      this.scoreButton = document.createElement("button");
      this.scoreButton.textContent = "FLI";
      this.scoreButton.onclick = () => setActiveMetric("score");
      this.styleButton(this.scoreButton, activeMetric === "score");

      // Append buttons to container
      this.container.appendChild(this.roiButton);
      this.container.appendChild(this.appreciationButton);
      this.container.appendChild(this.scoreButton);
    }

    // Apply styles to buttons and highlight the active one
    styleButton(button, isActive) {
      Object.assign(button.style, {
        padding: "8px 15px",
        border: "none",
        borderRadius: "20px",
        cursor: "pointer",
        fontWeight: "bold",
        background: isActive ? "#ffffff" : "none",
        color: isActive ? "black" : "white",
      });
    }

    // When control is added to the map
    onAdd(map) {
      return this.container;
    }

    // When control is removed
    onRemove() {
      this.container.parentNode.removeChild(this.container);
    }

    // Update button styles when metric changes
    updateButtonText(activeMetric) {
      this.styleButton(this.roiButton, activeMetric === "roi");
      this.styleButton(
        this.appreciationButton,
        activeMetric === "appreciation"
      );
      this.styleButton(this.scoreButton, activeMetric === "score");
    }
  }

  class ResetViewControl {
    constructor({ initialCenter, initialZoom }) {
      this.initialCenter = initialCenter; // Initial center of the map
      this.initialZoom = initialZoom; // Initial zoom level
    }

    onAdd(map) {
      this.map = map;

      // Create the button element
      this.button = document.createElement("button");
      this.button.className = "mapboxgl-ctrl-icon mapboxgl-ctrl-reset";
      this.button.type = "button";
      this.button.title = "Reset View";
      this.popupRef = popupRef; // Reference to the popup
      this.customPopupRef = customPopupRef; // Reference to the custom popup control
      this.button.innerHTML = "&#x21BB;"; // Use a refresh icon or any other icon

      // Add a click event listener to reset the map view
      this.button.addEventListener("click", () => {
        this.map.flyTo({
          center: this.initialCenter,
          zoom: this.initialZoom,
          essential: true, // Ensures the animation is not interrupted by user interactions
        });

        if (map.getLayer("state-boundary")) {
          map.removeLayer("state-boundary");
        }
        if (map.getLayer("highlighted-region")) {
          map.removeLayer("highlighted-region");
        }
        if (map.getSource("state-boundary")) {
          map.removeSource("state-boundary");
        }
        setCurrentStateId(null);
        setCurrentCity(null);
        // document.querySelector(".mapboxgl-ctrl-geocoder--input").value = "";
        const input = document.querySelector(".mapboxgl-ctrl-geocoder--input");
        if (input) {
          input.value = "";
        }

        // Popup cleanup logic
        if (this.popupRef.current) {
          console.log("popup removed");
          this.popupRef.current.remove(); // Ensure popup is removed when unmounting
          this.popupRef.current = null;
        }

        if (this.customPopupRef.current) {
          this.map.removeControl(this.customPopupRef.current);
          this.customPopupRef.current = null;
        }
      });

      // Create the container for the button
      this.container = document.createElement("div");
      this.container.className = "mapboxgl-ctrl mapboxgl-ctrl-group";
      this.container.appendChild(this.button);

      return this.container;
    }

    onRemove() {
      // Clean up the button and container
      this.button.removeEventListener("click", this.resetView);
      this.container.parentNode.removeChild(this.container);
      this.map = undefined;
    }
  }
  // Initialize Map
  useEffect(() => {
    // const initialCenter = [-95.7129, 37.0902]; // Center of US
    const initialCenter = isSubscribed
      ? [-95.7129, 37.0902]
      : [-86.2583, 39.8494]; // Center of US
    // const initialZoom = 3.5; // Initial zoom level
    const initialZoom = isSubscribed ? 3.5 : 9; // Initial zoom level
    const initializedMap = new mapboxgl.Map({
      container: "map",
      // style: 'mapbox://styles/mapbox/streets-v11',
      style: "mapbox://styles/mapbox/light-v11",

      center: initialCenter,
      zoom: initialZoom,
      minzoom: 3,
      projection: "mercator",
         // Restrict map movement to USA (with Alaska + Hawaii)
    maxBounds: [
      [-179.9, 17.5], // Southwest corner (Hawaii + Pacific)
      [-64.5, 71.5],  // Northeast corner (Maine + Alaska North)
    ],
    });
    initializedMap.setRenderWorldCopies(false);
    initializedMap.addControl(new mapboxgl.NavigationControl(), "bottom-right");

    // const toggleButtonControl = new MetricToggleButton(toggleMetric);
    // initializedMap.addControl(toggleButtonControl, 'bottom-left');

    // Add the custom ResetViewControl
    initializedMap.addControl(
      new ResetViewControl({
        initialCenter: initialCenter,
        initialZoom: initialZoom,
        popupRef: popupRef, // Pass the popup reference
        customPopupRef: customPopupRef, // Pass the custom popup reference
      }),
      "bottom-right" // Position it alongside the zoom controls
    );
    initializedMap.on("style.load", () => {
      setStyleLoaded(true); // Set the flag to true when the style is loaded
    });

    if (!isSubscribed) {
      initializedMap.on("load", async () => {
        try {
          const cityCoordinates = [
            [
              [-86.45, 40.05],
              [-86.25, 40.1],
              [-86.0, 40.0],
              [-85.95, 39.85],
              [-85.9, 39.7],
              [-86.0, 39.55],
              [-86.25, 39.5],
              [-86.45, 39.6],
              [-86.5, 39.75],
              [-86.45, 40.05],
            ],
          ];

          // Outer world polygon (covers entire screen)
          const outerCoordinates = [
            [-180, -90],
            [180, -90],
            [180, 90],
            [-180, 90],
            [-180, -90],
          ];

          // Mask polygon with a hole (city inside hole)
          const maskWithHole = {
            type: "FeatureCollection",
            features: [
              {
                type: "Feature",
                geometry: {
                  type: "Polygon",
                  coordinates: [outerCoordinates, ...cityCoordinates], // hole is 2nd ring
                },
                properties: {},
              },
            ],
          };

          // Add mask with city hole
          initializedMap.addSource("inactive-mask", {
            type: "geojson",
            data: maskWithHole,
          });

          initializedMap.addLayer({
            id: "gray-outside",
            type: "fill",
            source: "inactive-mask",
            layout: {},
            paint: {
              "fill-color": "#000",
              "fill-opacity": 0.4,
            },
          });

          // Add Indianapolis city source
          const cityGeoJSON = {
            type: "FeatureCollection",
            features: [
              {
                type: "Feature",
                properties: { name: "Indianapolis" },
                geometry: {
                  type: "Polygon",
                  coordinates: cityCoordinates,
                },
              },
            ],
          };

          initializedMap.addSource("indianapolis-city", {
            type: "geojson",
            data: cityGeoJSON,
          });

          // initializedMap.addLayer({
          //   id: 'white-city-fill',
          //   type: 'fill',
          //   source: 'indianapolis-city',
          //   layout: {},
          //   paint: {
          //     'fill-color': '#ffffff',
          //     'fill-opacity': 1
          //   }
          // });

          initializedMap.addLayer({
            id: "indianapolis-outline",
            type: "line",
            source: "indianapolis-city",
            layout: {},
            paint: {
              "line-color": "#0f5132",
              "line-width": 2,
            },
          });

          // Optional blocker to disable interactivity outside
          initializedMap.addLayer({
            id: "inactive-blocker",
            type: "fill",
            source: "inactive-mask",
            layout: {},
            paint: {
              "fill-color": "#000000",
              "fill-opacity": 0,
            },
          });

          initializedMap.on("click", (e) => {
            const features = initializedMap.queryRenderedFeatures(e.point, {
              layers: ["gray-outside"], // must match your city fill layer ID
              //   layers: ['indianapolis-outline'], // must match your city fill layer ID
            });

            if (features.length !== 0) {
              //   alert("This area is outside your subscription.");
              toast.error("This area is outside your subscription.");
            }
          });

          initializedMap.on("click", "inactive-blocker", (e) => {
            e.preventDefault();
            console.log("Interaction is disabled outside Indianapolis.");
          });
        } catch (err) {
          console.error("Error drawing mask and city:", err);
        }
      });
    }

    // Track the last selected state
    let lastSelectedState = null;

    //Statewise selection
    initializedMap.on("click", async (e) => {
      // Check if marker was clicked
      const features = initializedMap.queryRenderedFeatures(e.point, {
        layers: ["collisions"],
      });
      if (features.length > 0) return;

      const clickedLngLat = e.lngLat;
      const clickedPoint = turf.point([clickedLngLat.lng, clickedLngLat.lat]);

      // Ignore clicks inside popups
      const isMarkerClick =
        e.originalEvent.target.classList.contains("mapboxgl-popup");
      const clickedEl = e.originalEvent.target;
      const clickedInsidePopup = clickedEl.closest(".mapboxgl-popup");
      if (isMarkerClick || clickedInsidePopup) return;

      try {
        setSelectedZipcode(null);
        setCompareList([]);
        const response = await fetch("/assets/usa.geojson");
        const geojson = await response.json();

        // document.querySelector(".mapboxgl-ctrl-geocoder--input").value = "";
        const input = document.querySelector(".mapboxgl-ctrl-geocoder--input");
        if (input) {
          input.value = "";
        }

        const matchedFeature = geojson.features.find((feature) => {
          return turf.booleanPointInPolygon(clickedPoint, feature);
        });

        if (matchedFeature) {
          const clickedState = matchedFeature.properties.name;

          if (clickedState === lastSelectedState) {
            // Deselect state
            console.log("Deselected:", clickedState);
            lastSelectedState = null;
            setCurrentPopup(null);
            //  clear highlights
            // REMOVE EXISTING LAYERS AND SOURCES SAFELY
            if (initializedMap.getLayer("state-boundary")) {
              initializedMap.removeLayer("state-boundary");
            }
            if (initializedMap.getLayer("highlighted-region")) {
              initializedMap.removeLayer("highlighted-region");
            }
            if (initializedMap.getSource("state-boundary")) {
              initializedMap.removeSource("state-boundary");
            }
            setCurrentStateId(null);
            setCurrentCity(null);
          } else {
            console.log("Selected:", clickedState);
            lastSelectedState = clickedState;
            handleLocationSelect(clickedState, initializedMap, setCurrentPopup);
          }
        } else {
          console.log("Clicked location is not inside any state");
          lastSelectedState = null;
          setCurrentPopup(null);
        }
      } catch (err) {
        console.error("Error checking point in polygon:", err);
      }
    });

    //Handle general clicks on the map for geoJSON check (but skip if click was on a popup or the 'collisions' layer)

    //initializedMap.addControl(new ColorPalette(), 'bottom-left');

    setMap(initializedMap);

    // Add Mapbox Geocoder for state/region search
    const geocoder = new MapboxGeocoder({
      accessToken: mapboxgl.accessToken,
      countries: "us",
      //types: 'region,district,postcode,place', // Search for states/regions only
      types: "region,place,postcode", // region = state, place = city, postcode = zip
      placeholder: "Search for a state / zipcode",
      mapboxgl: mapboxgl,
      marker: false,
    });

    // Store globally so Header can re-attach
    window.geocoderInstance = geocoder;
    window.initializedMap = initializedMap;

    // Add geocoder to the map
    // initializedMap.addControl(geocoder, 'top-left');
    if (geocoderContainerRef.current) {
      geocoderContainerRef.current.appendChild(geocoder.onAdd(initializedMap));
    }
    geocoder.on("result", (event) => {
      // When a state is selected, zoom into the state and highlight its boundaries
      const result = event.result;
      const stateName = result.text; // Get the state name
      const stateCenter = result.center; // Coordinates for the state center
      const zipCode = result.text;
      console.log("stateName", stateName);
      console.log("detail popup", setCurrentPopup);
      //setCurrentPopup(null);
      //setSearchPincode(stateName); //set the search value
      //setPopupData(null);
      if (currentPopup) {
        currentPopup.remove(); // Close the previous popup
      }
      //document.querySelector(".mapboxgl-ctrl-top-right").innerHTML  = "";
      handleLocationSelect(stateName, initializedMap, setCurrentPopup);
    });

    // if (!hasFetchedRef.current) { // Only fetch if not already fetched
    // Initial API call to fetch properties

    //fetch('https://beta.flowlogic.com/api/web-map-plotting/')
    fetch("https://beta.flowlogic.com/api/map-plotting/", {
      // fetch('http://flowmap.uvjtech.in/api/map-plotting/', {
      method: "GET", // Default method is GET, but you can explicitly set it
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`, // Include the access token in the Authorization header
      },
    })
      .then((response) => response.json())
      .then((data) => {
        const properties = data.features.map((feature) => {
          const [lon, lat] = feature.geometry.coordinates;
          const modifiedROI = parseInt(feature.properties.roi, 10);
          const modifiedAppreciation = parseInt(
            feature.properties.appreciation,
            10
          );
          const sales = parseInt(feature.properties.sales, 10);
          return {
            zipcode: feature.properties.zipcode,
            roi: modifiedROI,
            bedrooms: feature.properties.bedrooms,
            state: feature.properties.state,
            rent: feature.properties.rent,
            city: feature.properties.city,
            score: feature.properties.score,
            sales: sales,
            appreciation: modifiedAppreciation,
            latitude: lat,
            longitude: lon,
            favorite: feature.properties.is_favorite,
          };
        });
        console.log("Initial Fetched Property List:", properties);
        setOriginalPropertyList(properties); // Store the original list of properties
        setPropertyList(properties); // Initially, show all properties

        // Calculate min and max sales values from the data
        const salesValues = properties.map((property) => property.sales);
        const minSalesValue = Math.min(...salesValues); // Find the minimum sales value
        const maxSalesValue = Math.max(...salesValues); // Find the maximum sales value

        setMinSales(minSalesValue); // Set the min sales value
        setMaxSales(maxSalesValue); // Set the max sales value
        setSliderMinSales(minSalesValue); // Set the min sales value
        setSliderMaxSales(maxSalesValue); // Set the max sales value

        const userAgent = window.navigator.userAgent.toLowerCase();
        const isMobile = /android|iphone|ipad|ipod/i.test(userAgent);
        if (isMobile) {
          setCurrentView("list");
        }
      })
      .catch((error) => console.error("Error loading GeoJSON:", error));
    // }

    // return () => initializedMap.remove();

    return () => {
      initializedMap.remove();
      window.geocoderInstance = null;
      window.initializedMap = null;
    };

    // }, []);
  }, [isSubscribed]);

  // const handleUpgrade = async () => {
  // console.log("button clicked")
  //     try {
  //     //   const response = await fetch('http://flowmap.uvjtech.in/api/users/subscription/add/', {
  //         const response = await fetch('https://beta.flowlogic.com/api/users/subscription/add/', {
  //         method: 'POST',
  //         headers: {
  //           'Content-Type': 'application/json',
  //           Authorization: `Bearer ${authToken}`,
  //         },
  //       });

  //       if (!response.ok) throw new Error('Subscription failed');

  //       if (response.ok) {
  //         localStorage.setItem('isSubscribed', 'true');
  //         setIsSubscribed(true);

  //     //   alert("You have successfully upgraded to a paid user");
  //       toast.success("You have successfully upgraded to a paid user");
  //       window.location.reload();
  //       } else {
  //         const data = await response.json();
  //         console.error('Upgrade failed:', data.message || 'Unknown error');
  //       }
  //     } catch (error) {
  //       console.error('Network error during upgrade:', error);
  //     }
  //   };

  useEffect(() => {
    if (map) {
      // If a MetricToggleButton control exists, remove it
      if (metricControl) {
        map.removeControl(metricControl);
      }

      // Create and add the new MetricToggleButton control
      const newToggleButtonControl = new MetricToggleButton(
        setActiveMetric,
        activeMetric
      );
      map.addControl(newToggleButtonControl, "top");

      // Update the button text when activeMetric changes
      newToggleButtonControl.updateButtonText(activeMetric);

      // Store the new control instance to track it for future updates
      setMetricControl(newToggleButtonControl);
    }
  }, [activeMetric, map]); // Re-run this effect when activeMetric changes

  //   // Helper function to format numbers with k, M, etc.
  // function formatCurrency(value) {
  //     if (value >= 1e6) {
  //         return '$' + (value / 1e6).toFixed(1) + 'M'; // For millions
  //     } else if (value >= 1e3) {
  //         return '$' + (value / 1e3).toFixed(1) + 'k'; // For thousands
  //     } else {
  //         return '$' + value.toLocaleString(); // For values less than 1000
  //     }
  // }

  function formatCurrency(value) {
    if (value >= 1e6) {
      return "$" + Math.floor(value / 1e6) + "M"; // For millions
    } else if (value >= 1e3) {
      return "$" + Math.floor(value / 1e3) + "k"; // For thousands
    } else {
      return "$" + Math.floor(value).toLocaleString(); // For values less than 1000
    }
  }

  class CustomPopupControl {
    constructor(htmlContent) {
      this._htmlContent = htmlContent;
    }

    onAdd() {
      this._container = document.createElement("div");
      this._container.className = "mapboxgl-ctrl custom-popup-control";

      // Set the inner HTML to the provided content
      this._container.innerHTML = this._htmlContent;

      // Store the container in the state (assumed `setCurrentPopup` is a setter for global state)
      setCurrentPopup(this._container); // Store in state
      console.log("popup created", currentPopup);
      // Call this function when initializing the popup
      // updateHeartIcon();  // Initial state of the heart based on `isFavorite`
      return this._container;
    }

    onRemove() {
      // Ensure that the container is still part of the DOM before attempting to remove it
      if (this._container && this._container.parentNode) {
        this._container.parentNode.removeChild(this._container);
      } else {
        console.warn("Popup control already removed or not yet added to DOM.");
      }

      this._map = undefined; // Clean up the map reference
    }
  }

  function closePopup() {
    if (currentPopup) {
      currentPopup.remove();
      setCurrentPopup(null); // Clear the reference // Clear the reference
    }
  }
  // Attach the function to the window object
  window.closePopup = closePopup;

  // Function to toggle the favorite state
  function toggleFavorite(zipcode, currentFav) {
    // {activeTab === 'favorites' &&(
    //     isFavorite = true

    // )}
    if (currentFav) {
      isFavorite = currentFav;
    }

    const url = isFavorite
      ? `https://beta.flowlogic.com/zip/favorite/remove/` // Endpoint to remove from favorites
      : `https://beta.flowlogic.com/zip/favorite/add/`; // Endpoint to add to favorites

    // ? `https://flowmap.uvj.in/zip/favorite/remove/`  // Endpoint to remove from favorites
    // : `https://flowmap.uvj.in/zip/favorite/add/`;  // Endpoint to add to favorites

    // Make the POST or DELETE request based on whether it's adding or removing
    fetch(url, {
      method: "POST", // Use DELETE for removing favorites
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`, // Include access token
      },
      body: JSON.stringify({ zipcode }), // Send the zipcode in the request body
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.data) {
          console.log("clicked property", zipcode);
          // Toggle the favorite state in the originalPropertyList
          setOriginalPropertyList((prevList) =>
            prevList.map(
              (property) =>
                property.zipcode === zipcode
                  ? { ...property, favorite: !property.favorite } // Toggle the favorite property
                  : property // Leave other properties unchanged
            )
          );
          if (isFavorite) {
            // Success message
            toast.error("Removed from favorites");
            // Remove from compareList if it's being unfavorited
            const updatedCompareList = compareList.filter(
              (zip) => zip !== zipcode
            );
            setCompareList(updatedCompareList); // Still update the state
            if (
              currentView === "list" &&
              activeTab === "favorites" &&
              selectedZipcode
            ) {
              showCompareDetails(updatedCompareList, originalPropertyList);
            }
          } else {
            toast.success("Added to favorites");
          }
          console.log("After favorites", originalPropertyList);
          isFavorite = !isFavorite; // Toggle the favorite state
          updateHeartIcon(isFavorite); // Update heart icon based on the favorite status
        } else {
          console.error("Failed to toggle favorite:", data);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }
  useEffect(() => {
    console.log("compareList", compareList);
    console.log("selectedZipcode", selectedZipcode);
    if (
      currentView === "list" &&
      activeTab === "favorites"
      //   &&
      //   selectedZipcode
    ) {
      showCompareDetails(compareList, originalPropertyList);
    }
  }, [compareList]);

  // Function to update the heart icon's visual state
  function updateHeartIcon(isFavorite) {
    let heartIconHTML = "";

    if (isFavorite) {
      // If it's a favorite, show filled heart icon and highlight the button
      heartIconHTML = `
               
                    <img src="/assets/favorite-fill.svg" alt="Favorite" /> <!-- Filled heart symbol -->
               `;
    } else {
      // If it's not a favorite, show outline heart icon and no highlight
      heartIconHTML = `
                
                    <img src="/assets/favorite.svg" alt="Not Favorite" /> <!-- Outline heart symbol -->
               `;
    }

    // Insert the updated heart icon HTML into the popup
    const favoriteButtonContainer = document.getElementById("favorite-button");
    if (favoriteButtonContainer) {
      favoriteButtonContainer.innerHTML = heartIconHTML; // Update the button with the new icon
    }
  }

  const handleLocationSelect = (
    location,
    map = "",
    setCurrentPopup,
    currentView = "split"
  ) => {
    if (!map) {
      console.error("Map is not initialized yet!");
      //return;
    }

    //
    setPopupData(null);

    if (popupRef.current) {
      console.log("popup removed");
      popupRef.current.remove(); // Ensure popup is removed when unmounting
      popupRef.current = null;
    }

    //setCurrentPopup(null);
    console.log("Selected Location:", location);
    setSearchPincode(location); // Set search value

    // Remove existing custom popup control before adding a new one
    if (customPopupRef.current) {
      map.removeControl(customPopupRef.current);
      customPopupRef.current = null;
    }
    // Fetch the boundary data
    fetchStateBoundary(location)
      .then(async (boundaryGeoJSON) => {
        console.log("Fetched Boundary", boundaryGeoJSON);

        // Ensure map is ready before modifying layers
        if (!map || !map.getStyle()) {
          console.error("Map is not fully loaded yet!");
          return;
        }

        // REMOVE EXISTING LAYERS AND SOURCES SAFELY
        if (map.getLayer("state-boundary")) {
          map.removeLayer("state-boundary");
        }
        if (map.getLayer("highlighted-region")) {
          map.removeLayer("highlighted-region");
        }
        if (map.getSource("state-boundary")) {
          map.removeSource("state-boundary");
        }

        //             map.addSource('mask', {
        //   type: 'geojson',
        //   data: {
        //     type: 'FeatureCollection',
        //     features: [
        //       {
        //         type: 'Feature',
        //         geometry: {
        //           type: 'Polygon',
        //           coordinates: [[
        //             [-180, -90], [180, -90],
        //             [180, 90], [-180, 90],
        //             [-180, -90]
        //           ]]
        //         }
        //       }
        //     ]
        //   }
        // });

        // // Add the dim layer
        // map.addLayer({
        //   id: 'dim-world',
        //   type: 'fill',
        //   source: 'mask',
        //   paint: {
        //     'fill-color': 'rgba(0, 0, 0, 0.4)'
        //   }
        // });
        // Add new boundary source
        map.addSource("state-boundary", {
          type: "geojson",
          data: boundaryGeoJSON,
        });

        if (isSubscribed) {
          // Add outline layer
          map.addLayer({
            id: "state-boundary",
            type: "line",
            source: "state-boundary",
            paint: {
              "line-color": "#1C8F7D",
              "line-width": 3,
            },
          });

          // Add fill highlight layer
          map.addLayer({
            id: "highlighted-region",
            type: "fill",
            source: "state-boundary",
            paint: {
              "fill-color": "#BEF2BE",
              "fill-opacity": 0.5,
            },
          });

          // Get bounding box and zoom
          const bbox = turf.bbox(boundaryGeoJSON);

          map.fitBounds(bbox, { padding: 50 });
        }

        // **Fetch Location Details for Tooltip**
        const isZipCode = /^\d+$/.test(location);

        if (isZipCode) {
          // Close previously opened popup
          console.log("Before closing popup, currentPopup:", currentPopup);
          // document.querySelector(".mapboxgl-ctrl-geocoder--input").value = "";
          const input = document.querySelector(
            ".mapboxgl-ctrl-geocoder--input"
          );
          if (input) {
            input.value = "";
          }

          if (currentPopup) {
            console.log("Closing existing popup");
            currentPopup.remove();
            setCurrentPopup(null); // Reset the currentPopup state
            console.log("Reset popup, currentPopup:", currentPopup);
          }
          console.log("After closing popup, currentPopup:", currentPopup);
          // Fetch Location Details API
          //const response = await fetch(`https://beta.flowlogic.com/api/web-reports/?type=expanded&zipcode=${location}`);
          console.log(
            `https://beta.flowlogic.com/api/web-reports/?type=compact&zipcode=${location}`
          );

          const url = `https://beta.flowlogic.com/api/reports/?type=expanded&zipcode=${location}`;

          const response = await fetch(url, {
            method: "GET", // Assuming GET method for fetching data
            headers: {
              Authorization: `Bearer ${authToken}`, // Pass the authToken as Authorization header
              "Content-Type": "application/json", // Add content type as JSON
            },
          });
          const responseData = await response.json();

          if (!responseData || responseData.results.length === 0) {
            console.error("No response data for location details.");
            return;
          }

          console.log("Location Details Response:", responseData);

          // Extract center coordinates
          const centerCoords =
            turf.centerOfMass(boundaryGeoJSON).geometry.coordinates;

          // Generate Popup HTML with all bedroom details
          //let popupHTML = `<strong>Zipcode:</strong> ${location} <br/><br/>`;

          // Extract general details from the first result (since all results have the same location details)
          const firstResult = responseData.results[0];
          const pincode = firstResult.zipcode;
          const county = firstResult.county_name;
          const metro = firstResult.metro;
          const city = firstResult.city;
          const state = firstResult.state;
          //const score = firstResult.score;
          const latest_year = firstResult.last_updated_sales_year;
          let popupHTML = `<div class="custom-popup">`;
          // Function to close the popup

          // **TOP HEADER SECTION**
          popupHTML += `<button class="popup-close-button" onClick="closePopup()">×</button>
                    <div class="popup-header">
                        
                        <div class="popup-text">
                            <div class="popup-title">
                                ${pincode} | ${city}
                            </div>
                            <div class="popup-subtitle"> ${county} | (${state}) |${latest_year}</div>
                        </div>
                    
                    
                `;

          const roiData = {};
          const scoreData = {};
          const appreciationData = {};
          const avgSalesData = {};
          const avgMonthlyRentData = {};
          const avgYearlyRentData = {};
          let favourites = 0;
          // Calculate average for each year

          //const salesData = { '2021': [], '2022': [], '2023': [], '2024': [] };

          const salesData = {};
          const averageSales = {};
          // Define offsets for historical sales data fields
          const salesFields = [
            { offset: 3, field: "sales_data_three" },
            { offset: 2, field: "sales_data_two" },
            { offset: 1, field: "sales_data_one" },
            { offset: 0, field: "avg_current_sales" },
          ];

          // Initialize salesData with dynamic year keys
          salesFields.forEach(({ offset }) => {
            const year = (latest_year - offset).toString();
            salesData[year] = [];
          });
          // Group properties by bedrooms
          responseData.results.forEach((property) => {
            const bedrooms = property.bedrooms || "Unknown";

            // responseData.results.forEach(property => {
            //     const { avg_current_sales, sales_data_one, sales_data_two, sales_data_three } = property;

            //     // We are assuming 'sales_data_one' corresponds to 2021, 'sales_data_two' to 2022, etc.
            //     salesData['2021'].push(parseFloat(sales_data_three));
            //     salesData['2022'].push(parseFloat(sales_data_two));
            //     salesData['2023'].push(parseFloat(sales_data_one));

            //     // Calculate avg_current_sales for each year
            //     salesData['2024'].push(parseFloat(avg_current_sales));
            // });

            // Object.keys(salesData).forEach(year => {
            //     const sum = salesData[year].reduce((a, b) => a + b, 0);
            //     averageSales[year] = sum / salesData[year].length;
            // });

            // Populate salesData dynamically
            responseData.results.forEach((property) => {
              salesFields.forEach(({ offset, field }) => {
                const year = (latest_year - offset).toString();
                const value = parseFloat(property[field]);
                console.log(year);
                console.log(value);
                if (!isNaN(value)) {
                  salesData[year].push(value);
                }
              });
            });

            // Calculate average sales for each year
            Object.keys(salesData).forEach((year) => {
              const values = salesData[year];
              const sum = values.reduce((a, b) => a + b, 0);
              averageSales[year] = values.length ? sum / values.length : 0;
            });

            // ROI data
            if (!roiData[bedrooms]) roiData[bedrooms] = [];
            roiData[bedrooms].push(`${property.roi}%`);

            // score data
            if (!scoreData[bedrooms]) scoreData[bedrooms] = [];

            // Ensure score is a valid number before adding
            const score = parseFloat(property.score);
            if (!isNaN(score)) {
              scoreData[bedrooms].push(score);
            }
            // Appreciation data
            if (!appreciationData[bedrooms]) appreciationData[bedrooms] = [];
            appreciationData[bedrooms].push(`${property.appreciation}%`);

            // Avg Sales data
            if (!avgSalesData[bedrooms]) avgSalesData[bedrooms] = 0;
            avgSalesData[bedrooms] += parseFloat(property.avg_current_sales);

            // Avg Monthly data
            if (!avgMonthlyRentData[bedrooms]) avgMonthlyRentData[bedrooms] = 0;
            avgMonthlyRentData[bedrooms] += parseFloat(
              property.avg_monthly_rent
            );

            // Avg Yearly data
            if (!avgYearlyRentData[bedrooms]) avgYearlyRentData[bedrooms] = 0;
            avgYearlyRentData[bedrooms] += parseFloat(property.avg_yearly_rent);

            //favourites
            // favourites = property.is_favorite;
            if (property.is_favorite === true) {
              favourites = 1;
            }
          });

          const totalScores = Object.values(scoreData)
            .flat()
            .filter((score) => !isNaN(score));
          const avgScore =
            totalScores.length > 0
              ? Math.round(
                  totalScores.reduce((acc, val) => acc + val, 0) /
                    totalScores.length
                )
              : 0; // Default to 0 if no valid scores

          // <!-- Heart Icon for Favorite -->

          if (favourites === 1) {
            popupHTML += `
                        <a id="favorite-button" class="popup-favorite-button highlighted">
                            <img src="/assets/favorite-fill.svg" alt="Favorite" /> <!-- Heart symbol -->
                        </a>`;
            isFavorite = true; // Set isFavorite to true since it's already marked as a favorite
          } else {
            popupHTML += `
                        <a id="favorite-button" class="popup-favorite-button">
                            <img src="/assets/favorite.svg" alt="Not Favorite" /> <!-- Heart symbol -->
                        </a>`;
            isFavorite = false; // Set isFavorite to false
          }
          popupHTML += ` </div>`; // main header close div
          //score
          popupHTML += `<div class="popup-heading"><div class="popup-subheading"><span>FLI</span> 
                 <span>${avgScore}</span></div></div>`;

          //graph

          popupHTML += `<div class="popup-content">
                    <canvas id="popupChart" width="300" height="150" style="display: ${
                      currentView !== "list" ? "block" : "none"
                    };"></canvas>
                     <canvas id="popupChartList" width="300" height="150" style="display: ${
                       currentView === "list" ? "block" : "none"
                     };"></canvas>
                   
                    </div> `;

          //    <PopupChart averageSales={averageSales} />
          //ROI
          popupHTML += `<div class="popup-heading"><div class="popup-subheading">ROI</div>
                `;
          // Append ROI details
          Object.keys(roiData).forEach((bedroom) => {
            popupHTML += `
                        <div class="popup-row">
                            <span class="popup-left">${bedroom} bd</span> 
                            <span class="popup-right"> ${roiData[bedroom].join(
                              ", "
                            )}</span>
                        </div>
                    `;
          });

          popupHTML += `</div>`;

          // Add Appreciation section
          popupHTML += `<div class="popup-heading"><div class="popup-subheading">Appreciation</div>`;

          // Iterate through appreciation data and format it as rows
          Object.keys(appreciationData).forEach((bedroom) => {
            popupHTML += `
                        <div class="popup-row">
                            <span class="popup-left">${bedroom} bd</span> 
                            <span class="popup-right">${appreciationData[
                              bedroom
                            ].join(", ")}</span>
                        </div>
                    `;
          });

          popupHTML += `</div>`;

          // Add Avg Sales section
          popupHTML += `<div class="popup-heading"><div class="popup-subheading">Avg Prop. Value</div>`;

          // Iterate through Sales data and format it as rows
          Object.keys(avgSalesData).forEach((bedroom) => {
            popupHTML += `
                         <div class="popup-row">
                             <span class="popup-left">${bedroom} bd</span> 
                            <span class="popup-right">$${Math.floor(
                              avgSalesData[bedroom]
                            ).toLocaleString()}</span>
                         </div>
                     `;
          });

          popupHTML += `</div>`;

          // Add Avg Montly Rent section
          //  popupHTML += `<div class="popup-heading"><div class="popup-subheading">Avg Monthly Rent</div>`;

          //  // Iterate through Avg Monthly Rent data and format it as rows
          //  Object.keys(avgMonthlyRentData).forEach(bedroom => {
          //      popupHTML += `
          //          <div class="popup-row">
          //              <span class="popup-left">${bedroom} bd</span>
          //             <span class="popup-right">$${avgMonthlyRentData[bedroom].toLocaleString()}</span>

          //          </div>
          //      `;
          //  });

          //  popupHTML +=`</div>`;

          //    // Add Avg Yearly Rent section
          //    popupHTML += `<div class="popup-heading"><div class="popup-subheading">Avg Yearly Rent</div>`;

          //    // Iterate through Avg Monthly Rent data and format it as rows
          //    Object.keys(avgYearlyRentData).forEach(bedroom => {
          //        popupHTML += `
          //            <div class="popup-row">
          //                <span class="popup-left">${bedroom} bd</span>
          //               <span class="popup-right">$${avgYearlyRentData[bedroom].toLocaleString()}</span>

          //            </div>
          //        `;
          //    });

          //    popupHTML +=`</div>`;

          popupHTML += `</div>`; // Close popup div

          const customPopupControl = new CustomPopupControl(popupHTML);
          map.addControl(customPopupControl, "top-right");
          customPopupRef.current = customPopupControl; // Store it in ref

          const favoriteButton = document.getElementById("favorite-button");
          if (favoriteButton) {
            favoriteButton.addEventListener("click", () => {
              toggleFavorite(pincode); // Use the location (zipcode) passed to the function
            });
          }

          setTimeout(() => {
            let canvas;
            if (currentView === "list") {
              canvas = document.getElementById("popupChartList");
            } else {
              canvas = document.getElementById("popupChart");
            }
            if (canvas) {
              const ctx = canvas.getContext("2d");
              //const years = ['2021', '2022', '2023', '2024']; // Years on the X-axis
              const years = Array.from({ length: 4 }, (_, i) =>
                String(latest_year - 3 + i)
              );

              const avgCurrentSales = years.map(
                (year) => averageSales[year] || 0
              );

              new Chart(ctx, {
                type: "line",
                data: {
                  labels: years, // X-axis labels
                  datasets: [
                    {
                      label: "Prop. Value",
                      data: avgCurrentSales, // Y-axis data
                      borderColor: "rgba(75, 192, 192, 1)",
                      borderWidth: 2,
                      fill: false,
                    },
                  ],
                },
                options: {
                  responsive: true,
                  maintainAspectRatio: false,
                  plugins: {
                    legend: { display: true, labels: { boxWidth: 0 } },
                    tooltip: {
                      callbacks: {
                        // Format tooltip to include $ sign and commas for thousands
                        label: function (tooltipItem) {
                          //return '$' + tooltipItem.raw.toLocaleString(); // Formats the tooltip value with $
                          return formatCurrency(tooltipItem.raw);
                        },
                      },
                    },
                  },
                  scales: {
                    x: { title: { display: false, text: "Year" } },
                    y: {
                      //beginAtZero: true,
                      title: { display: false, text: "Value ($)" },
                      ticks: {
                        // Format the y-axis ticks to include $ and commas
                        callback: function (value) {
                          //return '$' + value.toLocaleString(); // Formats Y-axis values with $
                          return formatCurrency(value); // Use the custom formatter
                        },
                      },
                    },
                  },
                },
              });
            } else {
              console.error("Chart canvas not found.");
            }
          }, 100); // Delay of 100ms to ensure canvas is rendered before Chart.js is initialized
        }
      })
      .catch((error) => {
        console.error("Error fetching boundary:", error);
      });
  };

  const handleLocationSelectList = (
    location,
    map = "",
    setCurrentPopup,
    currentView = "split"
  ) => {
    if (!map) {
      console.error("Map is not initialized yet!");
      //return;
    }

    //
    setPopupData(null);
    if (popupRef.current) {
      console.log("popup removed");
      popupRef.current.remove(); // Ensure popup is removed when unmounting
      popupRef.current = null;
    }

    //setCurrentPopup(null);
    console.log("Selected Location:", location);
    setSearchPincode(location); // Set search value

    // Remove existing custom popup control before adding a new one
    if (customPopupRef.current) {
      map.removeControl(customPopupRef.current);
      customPopupRef.current = null;
    }
    // REMOVE EXISTING LAYERS AND SOURCES SAFELY
    if (map.getLayer("state-boundary")) {
      map.removeLayer("state-boundary");
    }
    if (map.getLayer("highlighted-region")) {
      map.removeLayer("highlighted-region");
    }
    if (map.getSource("state-boundary")) {
      map.removeSource("state-boundary");
    }
    // Fetch the boundary data
    fetchStateBoundary(location)
      .then(async (boundaryGeoJSON) => {
        console.log("Fetched Boundary", boundaryGeoJSON);

        // **Fetch Location Details for Tooltip**
        const isZipCode = /^\d+$/.test(location);

        if (isZipCode) {
          // Close previously opened popup
          console.log("Before closing popup, currentPopup:", currentPopup);
          // document.querySelector(".mapboxgl-ctrl-geocoder--input").value = "";
          const input = document.querySelector(
            ".mapboxgl-ctrl-geocoder--input"
          );
          if (input) {
            input.value = "";
          }

          if (currentPopup) {
            console.log("Closing existing popup");
            currentPopup.remove();
            setCurrentPopup(null); // Reset the currentPopup state
            console.log("Reset popup, currentPopup:", currentPopup);
          }
          console.log("After closing popup, currentPopup:", currentPopup);
          // Fetch Location Details API
          //const response = await fetch(`https://beta.flowlogic.com/api/web-reports/?type=expanded&zipcode=${location}`);
          //console.log(`https://beta.flowlogic.com/api/web-reports/?type=compact&zipcode=${location}`);

          const url = `https://beta.flowlogic.com/api/reports/?type=expanded&zipcode=${location}`;

          const response = await fetch(url, {
            method: "GET", // Assuming GET method for fetching data
            headers: {
              Authorization: `Bearer ${authToken}`, // Pass the authToken as Authorization header
              "Content-Type": "application/json", // Add content type as JSON
            },
          });
          const responseData = await response.json();

          if (!responseData || responseData.results.length === 0) {
            console.error("No response data for location details.");
            return;
          }

          console.log("Location Details Response:", responseData);

          // Extract center coordinates
          //const centerCoords = turf.centerOfMass(boundaryGeoJSON).geometry.coordinates;+

          // Generate Popup HTML with all bedroom details
          //let popupHTML = `<strong>Zipcode:</strong> ${location} <br/><br/>`;

          // Extract general details from the first result (since all results have the same location details)
          const firstResult = responseData.results[0];
          const pincode = firstResult.zipcode;
          const county = firstResult.county_name;
          const metro = firstResult.metro;
          const city = firstResult.city;
          const state = firstResult.state;
          //const score = firstResult.score;

          //  let popupHTML = `<div class="custom-popup-list">`;
          let popupHeight = "auto"; // default collapsed

          // Step 1: HTML string with arrow
          let popupHTML = `
  <div class="custom-popup-list" 
       style="height: ${popupHeight}; transition: height 0.3s ease; overflow-y: auto; position: relative;">
    <span id="popupToggleArrow"
          style="cursor: pointer; font-size: 20px; position: absolute; top: 10px; right: 50px; z-index: 10;">
      ⬆️
    </span>
   
`;
          // Function to close the popup

          // **TOP HEADER SECTION**
          popupHTML += `
                    <div class="popup-header">
                        
                        <div class="popup-title-wrap"><div class="popup-text">
                            <div class="popup-title">
                                ${pincode} | ${city}
                            </div>
                            <div class="popup-subtitle"> ${county} | (${state})</div>
                        </div>
                    
                    
                `;

          const roiData = {};
          const scoreData = {};
          const appreciationData = {};
          const avgSalesData = {};
          const avgMonthlyRentData = {};
          const avgYearlyRentData = {};
          let favourites = 0;
          // Calculate average for each year
          const latest_year = firstResult.last_updated_sales_year;

          // Define offsets for historical sales data fields
          const salesFields = [
            { offset: 3, field: "sales_data_three" },
            { offset: 2, field: "sales_data_two" },
            { offset: 1, field: "sales_data_one" },
            { offset: 0, field: "avg_current_sales" },
          ];

          // Initialize structures
          const salesData = {};
          const averageSales = {};

          // Initialize salesData with dynamic year keys
          salesFields.forEach(({ offset }) => {
            const year = (latest_year - offset).toString();
            salesData[year] = [];
          });
          // Group properties by bedrooms
          responseData.results.forEach((property) => {
            const bedrooms = property.bedrooms || "Unknown";

            responseData.results.forEach((property) => {
              salesFields.forEach(({ offset, field }) => {
                const year = (latest_year - offset).toString();
                const value = parseFloat(property[field]);
                if (!isNaN(value)) {
                  salesData[year].push(value);
                }
              });
            });

            // Calculate average sales for each year
            Object.keys(salesData).forEach((year) => {
              const values = salesData[year];
              const sum = values.reduce((a, b) => a + b, 0);
              averageSales[year] = values.length ? sum / values.length : 0;
            });

            // ROI data
            if (!roiData[bedrooms]) roiData[bedrooms] = [];
            roiData[bedrooms].push(`${property.roi}%`);

            // score data
            if (!scoreData[bedrooms]) scoreData[bedrooms] = [];

            // Ensure score is a valid number before adding
            const score = parseFloat(property.score);
            if (!isNaN(score)) {
              scoreData[bedrooms].push(score);
            }
            // Appreciation data
            if (!appreciationData[bedrooms]) appreciationData[bedrooms] = [];
            appreciationData[bedrooms].push(`${property.appreciation}%`);

            // Avg Sales data
            if (!avgSalesData[bedrooms]) avgSalesData[bedrooms] = 0;
            avgSalesData[bedrooms] += parseFloat(property.avg_current_sales);

            // Avg Monthly data
            if (!avgMonthlyRentData[bedrooms]) avgMonthlyRentData[bedrooms] = 0;
            avgMonthlyRentData[bedrooms] += parseFloat(
              property.avg_monthly_rent
            );

            // Avg Yearly data
            if (!avgYearlyRentData[bedrooms]) avgYearlyRentData[bedrooms] = 0;
            avgYearlyRentData[bedrooms] += parseFloat(property.avg_yearly_rent);

            //favourites
            // favourites = property.is_favorite;
            if (property.is_favorite === true) {
              favourites = 1;
            }
          });

          const totalScores = Object.values(scoreData)
            .flat()
            .filter((score) => !isNaN(score));
          const avgScore =
            totalScores.length > 0
              ? Math.round(
                  totalScores.reduce((acc, val) => acc + val, 0) /
                    totalScores.length
                )
              : 0; // Default to 0 if no valid scores

          // <!-- Heart Icon for Favorite -->

          if (favourites === 1) {
            popupHTML += `
                        <a id="favorite-button" class="popup-favorite-button highlighted">
                            <img src="/assets/favorite-fill.svg" alt="Favorite" /> <!-- Heart symbol -->
                        </a>`;
            isFavorite = true; // Set isFavorite to true since it's already marked as a favorite
          } else {
            popupHTML += `
                        <a id="favorite-button" class="popup-favorite-button">
                            <img src="/assets/favorite.svg" alt="Not Favorite" /> <!-- Heart symbol -->
                        </a>`;
            isFavorite = false; // Set isFavorite to false
          }
          popupHTML += `</div><button class="popup-close-button" id="popup-close-btn">×</button> </div>`; // main header close div
          //score
          popupHTML += `<div class="popup-heading"><div class="popup-subheading"><span>Flow Logic Index</span> 
                 <span>${avgScore}</span></div></div>`;

          //graph

          popupHTML += `<div class="popup-content">
                     <canvas id="popupChartList" width="300" height="150"></canvas>
                   
                    </div> `;

          //    <PopupChart averageSales={averageSales} />
          //ROI
          popupHTML += `<div class="popup-heading"><div class="popup-subheading">ROI</div>
                `;
          // Append ROI details
          Object.keys(roiData).forEach((bedroom) => {
            popupHTML += `
                        <div class="popup-row">
                            <span class="popup-left">${bedroom} bd</span> 
                            <span class="popup-right"> ${roiData[bedroom].join(
                              ", "
                            )}</span>
                        </div>
                    `;
          });

          popupHTML += `</div>`;

          // Add Appreciation section
          popupHTML += `<div class="popup-heading"><div class="popup-subheading">Appreciation</div>`;

          // Iterate through appreciation data and format it as rows
          Object.keys(appreciationData).forEach((bedroom) => {
            popupHTML += `
                        <div class="popup-row">
                            <span class="popup-left">${bedroom} bd</span> 
                            <span class="popup-right">${appreciationData[
                              bedroom
                            ].join(", ")}</span>
                        </div>
                    `;
          });

          popupHTML += `</div>`;

          // Add Avg Sales section
          popupHTML += `<div class="popup-heading"><div class="popup-subheading">Avg Prop. Value</div>`;

          // Iterate through Sales data and format it as rows
          Object.keys(avgSalesData).forEach((bedroom) => {
            popupHTML += `
                         <div class="popup-row">
                             <span class="popup-left">${bedroom} bd</span> 
                            <span class="popup-right">$${Math.floor(
                              avgSalesData[bedroom]
                            ).toLocaleString()}</span>
                         </div>
                     `;
          });

          popupHTML += `</div>`;

          //                   // Add Avg Montly Rent section
          //  popupHTML += `<div class="popup-heading"><div class="popup-subheading">Avg Monthly Rent</div>`;

          //  // Iterate through Avg Monthly Rent data and format it as rows
          //  Object.keys(avgMonthlyRentData).forEach(bedroom => {
          //      popupHTML += `
          //          <div class="popup-row">
          //              <span class="popup-left">${bedroom} bd</span>
          //             <span class="popup-right">$${avgMonthlyRentData[bedroom].toLocaleString()}</span>

          //          </div>
          //      `;
          //  });

          //  popupHTML +=`</div>`;

          // Add Avg Yearly Rent section
          popupHTML += `<div class="popup-heading"><div class="popup-subheading">Avg Yearly Rent</div>`;

          // Iterate through Avg Monthly Rent data and format it as rows
          Object.keys(avgYearlyRentData).forEach((bedroom) => {
            popupHTML += `
                           <div class="popup-row">
                               <span class="popup-left">${bedroom} bd</span> 
                              <span class="popup-right">$${avgYearlyRentData[
                                bedroom
                              ].toLocaleString()}</span>
  
                           </div>
                       `;
          });

          popupHTML += `</div>`;

          popupHTML += `</div>`; // Close popup div

          // const customPopupControl = new CustomPopupControl(popupHTML);
          // map.addControl(customPopupControl, 'top-right');
          //customPopupRef.current = customPopupControl; // Store it in ref
          document.getElementById("detailed_popup").style.display = "block";

          document.getElementById("detailed_popup").innerHTML = popupHTML;
          setPopupHTML(popupHTML);

          // Attach click after injection

          const outerPopup = document.getElementById("detailed_popup");
          const arrowEl = document.getElementById("popupToggleArrow");

          // Toggle height on click
          arrowEl.addEventListener("click", function () {
            if (outerPopup.style.maxHeight === "100vh") {
              outerPopup.style.maxHeight = "300px"; // collapse
            } else {
              outerPopup.style.maxHeight = "100vh"; // expand
              outerPopup.style.height = "auto";
            }
          });
          setTimeout(() => {
            const closeBtn = document.getElementById("popup-close-btn");
            if (closeBtn) {
              closeBtn.onclick = () => {
                setPopupHTML(null);
                document.getElementById("detailed_popup").style.display =
                  "none";
              };
            }
          }, 0);

          const favoriteButton = document.getElementById("favorite-button");
          if (favoriteButton) {
            favoriteButton.addEventListener("click", () => {
              toggleFavorite(pincode); // Use the location (zipcode) passed to the function
            });
          }

          setTimeout(() => {
            let canvas;

            canvas = document.getElementById("popupChartList");

            if (canvas) {
              const ctx = canvas.getContext("2d");
              //const years = ['2021', '2022', '2023', '2024']; // Years on the X-axis
              const years = Array.from({ length: 4 }, (_, i) =>
                String(latest_year - 3 + i)
              );
              const avgCurrentSales = years.map(
                (year) => averageSales[year] || 0
              );

              new Chart(ctx, {
                type: "line",
                data: {
                  labels: years, // X-axis labels
                  datasets: [
                    {
                      label: "Prop. Value",
                      data: avgCurrentSales, // Y-axis data
                      borderColor: "rgba(75, 192, 192, 1)",
                      borderWidth: 2,
                      fill: false,
                    },
                  ],
                },
                options: {
                  responsive: true,
                  maintainAspectRatio: false,
                  plugins: {
                    legend: { display: true, labels: { boxWidth: 0 } },
                    tooltip: {
                      callbacks: {
                        // Format tooltip to include $ sign and commas for thousands
                        label: function (tooltipItem) {
                          //return '$' + tooltipItem.raw.toLocaleString(); // Formats the tooltip value with $
                          return formatCurrency(tooltipItem.raw);
                        },
                      },
                    },
                  },
                  scales: {
                    x: { title: { display: false, text: "Year" } },
                    y: {
                      //beginAtZero: true,
                      title: { display: false, text: "Value ($)" },
                      ticks: {
                        // Format the y-axis ticks to include $ and commas
                        callback: function (value) {
                          //return '$' + value.toLocaleString(); // Formats Y-axis values with $
                          return formatCurrency(value); // Use the custom formatter
                        },
                      },
                    },
                  },
                },
              });
            } else {
              console.error("Chart canvas not found.");
            }
          }, 100); // Delay of 100ms to ensure canvas is rendered before Chart.js is initialized
        }
      })
      .catch((error) => {
        console.error("Error fetching boundary:", error);
      });
  };
  // Helper function to position the popup in the top-left area
  function positionPopupInTopLeft(popup) {
    const popupElement = popup.getElement();

    // Add a custom class to the popup for styling
    popupElement.classList.add("top-left-popup");

    // Append the popup to the map's top-left area
    const topLeftContainer = document.querySelector(".mapboxgl-ctrl-top-left");
    topLeftContainer.appendChild(popupElement);
  }
  const transformToGeoJSON = (apiResponse) => {
    return {
      type: "FeatureCollection",
      features: [
        {
          type: "Feature",
          geometry: {
            type: "Polygon",
            coordinates: [apiResponse.coordinates],
          },
          properties: {
            postcode: apiResponse.postcode,
          },
        },
      ],
    };
  };
  const fetchStateBoundary = async (location) => {
    try {
      // Check if the location is a zip code (numeric check)
      const isZipCode = /^\d+$/.test(location);

      if (isZipCode) {
        // const response = await fetch(`https://beta.flowlogic.com/api/location/${location}/`);
        // console.log(`https://beta.flowlogic.com/api/location/${location}/`);
        const response = await fetch(
          `https://beta.flowlogic.com/api/location/${location}/`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${authToken}`, // Make sure authToken is defined
              "Content-Type": "application/json",
            },
          }
        );

        if (!response.ok) {
          throw new Error(
            `Failed to fetch zip code boundary, status: ${response.status}`
          );
        }

        const apiResponse = await response.json();
        console.log("API Response:", apiResponse);

        const boundaryGeoJSON = transformToGeoJSON(apiResponse);
        console.log("Transformed GeoJSON:", boundaryGeoJSON);

        setCurrentStateId(null);
        setCurrentCity(null);
        return boundaryGeoJSON;
      } else {
        // Fetch boundary for state from the GeoJSON file
        const response = await fetch("/assets/usa.geojson"); // Path to your GeoJSON file

        if (!response.ok) {
          throw new Error(
            `Failed to fetch state boundary, status: ${response.status}`
          );
        }

        const boundaryGeoJSON = await response.json();

        // Find the state's boundary in the GeoJSON
        const stateBoundary = boundaryGeoJSON.features.find(
          (feature) =>
            feature.properties.name.toLowerCase() === location.toLowerCase()
        );

        if (stateBoundary) {
          setCurrentCity(null);
          setCurrentStateId(stateBoundary.id); // Save the state ID for later use
          console.log("state Id", currentStateId);
          return stateBoundary; // Return state boundary
        } else {
          //throw new Error(`Boundary for ${location} not found`);
          setCurrentStateId(null);
          setCurrentCity(location);
        }
      }
    } catch (error) {
      console.error("Error fetching boundary:", error);
      return null;
    }
  };

  const calculateZoomLevel = (bbox) => {
    const [minLng, minLat, maxLng, maxLat] = bbox;
    const latDiff = maxLat - minLat;
    const lngDiff = maxLng - minLng;

    // Adjust these values based on your needs
    if (latDiff > 10 || lngDiff > 10) return 4; // Zoom out for large areas
    if (latDiff > 5 || lngDiff > 5) return 6; // Medium zoom
    return 8; // Zoom in for small areas
  };

  const setMapData = (mapInstance, properties) => {
    if (!mapInstance || !styleLoaded) {
      console.log("Map instance or style is not loaded yet");
      return;
    }

    // Remove existing layers and sources if they exist
    if (mapInstance.getLayer("collisions")) {
      mapInstance.removeLayer("collisions");
    }
    if (mapInstance.getLayer("roi-labels")) {
      mapInstance.removeLayer("roi-labels");
    }
    if (mapInstance.getSource("collisions")) {
      mapInstance.removeSource("collisions");
    }

    //console.log("enter setMapData");
    //console.log("mapInstance", mapInstance);
    console.log("properties in setMapData", properties);

    // Add the source for collisions (properties)
    mapInstance.addSource("collisions", {
      type: "geojson",
      data: {
        type: "FeatureCollection",
        features: properties.map((property) => ({
          type: "Feature",
          geometry: {
            type: "Point",
            coordinates: [property.longitude, property.latitude],
          },
          properties: {
            zipcode: property.zipcode,
            roi: property.roi,
            bedrooms: property.bedrooms,
            appreciation: property.appreciation,
            score: property.score,
            rent: property.rent,
            state: property.state,
            city: property.city,
          },
        })),
      },
    });

    const appreciationColors = [
      "step",
      ["get", "appreciation"],
      "#acacac",
      0,
      "#FFE36B",
      5,
      "#FFB36B",
      10,
      "#FE5C5C",
      15,
      "#F26BFF",
      20,
      "#CE1E50",
    ];

    const defaultColors = [
      "step",
      ["get", activeMetric],
      "#acacac",
      0,
      "#acacac",
      5,
      "#FFE36B",
      10,
      "#FFB36B",
      15,
      "#FE5C5C",
      20,
      "#F26BFF",
      25,
      "#CE1E50",
    ];

    // Add the 'collisions' layer
    mapInstance.addLayer({
      id: "collisions",
      type: "circle",
      source: "collisions",
      paint: {
        "circle-radius": [
          "interpolate",
          ["linear"],
          ["zoom"],
          0,
          3,
          4,
          10,
          6,
          16,
          8,
          20,
          10,
          24,
        ],
        // 'circle-color': [
        //     'step',
        //     ['get', activeMetric],
        //     '#acacac',
        //     0, '#acacac',
        //     5, '#FFE36B',
        //     10, '#FFB36B',
        //     15, '#FE5C5C',
        //     20, '#F26BFF',
        //     25, '#CE1E50',
        // ],
        "circle-color":
          activeMetric === "appreciation" ? appreciationColors : defaultColors,

        //         'circle-stroke-color': '#000000',   // Black border
        // 'circle-stroke-width': 1.5,         // Border width
        // 'circle-stroke-opacity': 0.8,       // Optional: opacity
      },
    });

    // Add the 'roi-labels' layer (labels showing active metric)
    mapInstance.addLayer({
      id: "roi-labels",
      type: "symbol",
      source: "collisions",
      minzoom: 4, // Labels will appear at zoom level 4 and above
      layout: {
        "text-field": ["get", activeMetric],
        "text-size": 10,
        "text-allow-overlap": false, // <- this allows overlapping text
      },
      paint: {
        "text-color": [
          "step",
          ["number", ["get", activeMetric]],
          "#000000",
          10,
          "#000000",
          15,
          "#000000",
          20,
          "#000000",
          25,
          "#000000",
        ],
      },
    });
    // Set visibility of roi-labels layer based on zoom level
    // mapInstance.on('zoom', function() {
    //     var zoomLevel = mapInstance.getZoom();
    //     console.log('zoomlevel',zoomLevel)
    //     if (zoomLevel >= 4) {
    //         mapInstance.setLayoutProperty('roi-labels', 'visibility', 'visible');
    //     } else {
    //         mapInstance.setLayoutProperty('roi-labels', 'visibility', 'none');
    //     }
    // });
    // marker click
    map.on("click", "collisions", clickHandler);
  };

  // Define clickHandler outside useEffect

  // Define the clickHandler function outside useEffect
  const clickHandler = (e) => {
    const feature = e.features && e.features[0];
    if (!feature) return; // Exit if no feature was clicked

    const { zipcode, roi, score, appreciation, city, state } =
      feature.properties;
    const coordinates = feature.geometry.coordinates;

    // Remove the previous popup if it exists
    if (popupRef.current) {
      popupRef.current.remove();
      popupRef.current = null;
    }

    // Create new popup content
    const popupContent = `
        <div class="tooltipOuter">
            <div class="tooltipTitle"><span>${zipcode}</span><span class="grey">${city}, ${state}</span></div>
            <div class="tooltipContentOuter">
                <div class="tooltipContent">
                    <div class="tooltipValues"><span><strong>ROI</strong></span> <span>${roi}%</span></div>
                    <div class="tooltipValues"><span><strong>Appreciation</strong></span> <span>${appreciation}%</span></div>
                    <div class="tooltipValues"><span><strong>FLI</strong></span> <span>${score}</span></div>
                    
                </div>
                <div class="tooltipViewBtn">
                    <button id="viewMoreBtn">
                        <span>Explore</span> <img src="/assets/arw-grey.svg" alt="FlowLogic Icon" />
                    </button>
                </div>
            </div>
        </div>
    `;

    //  Create and store the new popup in a ref (prevents re-renders)
    const newPopup = new mapboxgl.Popup({
      closeButton: true,
      closeOnClick: true,
    })
      .setLngLat(coordinates)
      .setHTML(popupContent)
      .addTo(map);

    popupRef.current = newPopup; // Store popup in ref to prevent duplicates

    // Attach "View More" button event AFTER rendering
    setTimeout(() => {
      const viewMoreBtn = document.getElementById("viewMoreBtn");
      if (viewMoreBtn) {
        viewMoreBtn.onclick = () =>
          handleLocationSelect(zipcode, map, setCurrentPopup);
      }
    }, 100);
  };

  //  useEffect with proper cleanup
  // useEffect(() => {
  //     if (!map) return;

  //     // Remove any previous event listener before adding a new one
  //     map.off('click', 'collisions', clickHandler);
  //     map.on('click', 'collisions', clickHandler);

  //     // Cleanup: remove event listener when component unmounts
  //     return () => {
  //         map.off('click', 'collisions', clickHandler);
  //         if (popupRef.current) {
  //             popupRef.current.remove(); // Ensure popup is removed when unmounting
  //             popupRef.current = null;
  //         }
  //     };
  // }, [map]); // Runs only when `map` changes

  const handleTabChange = (tab) => {
    console.log("Tab clicked:", tab);

    //  // Set loading to true before filtering
    if (activeTab === tab) {
      console.log("same tab");
      setForceRerender((prev) => !prev); // Toggle forceRerender to force update
      updateFilter();
    } else {
      setActiveTab(tab); // Set active tab only if it's different
    }
    setIsLoading(true);
    setCurrentStateId(null);
    setCurrentCity(null);
    // document.querySelector(".mapboxgl-ctrl-geocoder--input").value = "";
    const input = document.querySelector(".mapboxgl-ctrl-geocoder--input");
    if (input) {
      input.value = "";
    }

    // REMOVE EXISTING LAYERS AND SOURCES SAFELY
    if (map.getLayer("state-boundary")) {
      map.removeLayer("state-boundary");
    }
    if (map.getLayer("highlighted-region")) {
      map.removeLayer("highlighted-region");
    }
    if (map.getSource("state-boundary")) {
      map.removeSource("state-boundary");
    }
    if (currentView === "list") {
      setPopupHTML(null);
      setSelectedZipcode(null);
      document.getElementById("detailed_popup").style.display = "none";
    }
    //if (tab === "favorites") {
    // Resize the map before updating the filter
    map.flyTo({
      center: isSubscribed ? [-95.7129, 37.0902] : [-86.2583, 39.8494],
      zoom: isSubscribed ? 3.5 : 9,
      essential: true, // Ensures the animation is not interrupted by user interactions
    });
    //}
  };

  const updateFilter = (stateName = "") => {
    console.log("Enter updateFilter", stateName);
    if (!styleLoaded || !map) {
      console.log("Map style is not loaded yet");
      return;
    }

    setPopupInstance(null);
    if (popupInstance) {
      popupInstance.remove(); // Remove the previous popup
      setPopupInstance(null);
      console.log("after drag small popup", popupInstance);
    }
    // Ensure originalPropertyList is available
    if (originalPropertyList && originalPropertyList.length > 0) {
      // Function to filter properties by current map bounds and active metric filter
      if (!map || !styleLoaded) {
        console.log("Map instance or style is not loaded yet");
        return;
      }

      const filterProperties = () => {
        // Get current map bounds
        const bounds = map.getBounds();
        const sw = bounds.getSouthWest();
        const ne = bounds.getNorthEast();
        // console.log(sw);
        // console.log(ne);
        // console.log(searchPincode);
        // Apply the ROI or Appreciation filter and map bounds filtering

        // Step 1: Filter properties based on the active tab (Favorites or All)
        console.log("tab", activeTab);

        ///working script for favorites
        const filteredByTab =
          activeTab === "favorites"
            ? originalPropertyList.filter((property) => property.favorite) // Only favorites
            : originalPropertyList; // All properties

        // const filteredProperties = originalPropertyList.filter((property) => {
        const filteredProperties = filteredByTab.filter((property) => {
          const lat = parseFloat(property.latitude);
          const lng = parseFloat(property.longitude);
          const propertyZipcode = property.zipcode;

          // Ensure valid coordinates
          if (isNaN(lat) || isNaN(lng)) return false;

          // If no zipcode filter, apply map bounds and ROI filter
          // const isWithinBounds = lat >= sw.lat && lat <= ne.lat && lng >= sw.lng && lng <= ne.lng;

          // Apply map bounds only if NOT in favorites tab
          const isWithinBounds =
            activeTab === "favorites"
              ? true
              : lat >= sw.lat &&
                lat <= ne.lat &&
                lng >= sw.lng &&
                lng <= ne.lng;

          // Apply ROI, Appreciation, and Score filters

          const meetsROIFilter =
            roiFilter === "All" || property.roi >= roiFilter;
          //const meetsAppreciationFilter = appreciationFilter ? property.appreciation >= appreciationFilter : true;
          const meetsAppreciationFilter =
            appreciationFilter === "All" ||
            property.appreciation >= appreciationFilter;
          //const meetsScoreFilter = scoreFilter ? property.score >= scoreFilter : true;
          const meetsScoreFilter =
            scoreFilter === "All" || property.score >= scoreFilter;
          const meetsSalesFilter =
            property.sales >= minSales && property.sales <= maxSales;

          // return isWithinBounds && meetsROIFilter;
          return (
            isWithinBounds &&
            meetsROIFilter &&
            meetsAppreciationFilter &&
            meetsScoreFilter &&
            meetsSalesFilter
          );
        });

        return filteredProperties;
      };

      // Get the filtered properties based on the bounds and active filter
      const filteredProperties = filterProperties();

      console.log("Filtered Property List:", filteredProperties);

      // Sort the filtered properties
      const sortedProperties = sortProperties(
        filteredProperties,
        sortKey,
        sortOrder
      );
      // Update the propertyList state with filtered properties
      //setPropertyList(filteredProperties);
      setPropertyList(sortedProperties);
      setIsLoading(false);
      // Remove existing layers and sources if they exist
      if (map.getLayer("collisions")) {
        map.removeLayer("collisions");
      }
      if (map.getLayer("roi-labels")) {
        map.removeLayer("roi-labels");
      }
      if (map.getSource("collisions")) {
        map.removeSource("collisions");
      }

      // Reuse setMapData to update the map with filtered properties
      setMapData(map, sortByROI(filteredProperties)); // Update map with filtered properties
    } else {
      console.log("No properties available to filter.");
    }
  };

  useEffect(() => {
    if (map) {
      console.log("Enter map");
      // Bind to map movement (zoom or pan)
      map.on("moveend", () => {
        console.log("movened");
        updateFilter(); // Filter properties based on the current map bounds
      });

      // Bind to zoom events (optional, but useful for map interaction)
      // map.on('zoomend', () => {
      //     console.log("movenzoomed");
      //     updateFilter(); // Reapply filters after zoom
      // });

      // Call updateFilter initially to apply filter based on the initial map state
      updateFilter();
    }
  }, [
    activeTab,
    roiFilter,
    appreciationFilter,
    scoreFilter,
    activeMetric,
    originalPropertyList,
    searchPincode,
    minSales,
    maxSales,
  ]);

  class ColorPalette1 {
    constructor() {
      this.container = document.createElement("div");
      this.container.className =
        "mapboxgl-ctrl mapboxgl-ctrl-group color-palatte-outer";
      this.container.style.bottom = "10px";
      this.container.style.left = "10px";
      this.updateContent();
    }

    updateContent() {
      this.container.innerHTML = "";
      const colorLegendContainer = document.createElement("div");
      colorLegendContainer.style.display = "flex";

      roiColors[activeMetric].map((item) => {
        const colorBlock = document.createElement("div");
        colorBlock.className = "color-palatte-single";
        colorBlock.style.backgroundColor = item.color;

        const label = document.createElement("div");
        //label.textContent = item.label + '+';
        label.textContent =
          item.label === "All"
            ? item.label
            : activeMetric !== "score"
            ? `${item.label}%`
            : `${item.label}+`;

        colorBlock.appendChild(label);

        colorBlock.addEventListener("click", () => {
          console.log("selected lable", item.label);
          if (activeMetric == "roi") {
            setRoiFilter(parseInt(item.label, 10));
            setAppreciationFilter("All");
            setScoreFilter("All");
          } else if (activeMetric == "appreciation") {
            //setAppreciationFilter(parseInt(item.label, 10));
            setAppreciationFilter(
              item.label === "All" ? "All" : parseInt(item.label, 10)
            );
            setRoiFilter("All");
            setScoreFilter("All");
          } else if (activeMetric == "score") {
            setScoreFilter(parseInt(item.label, 10));
            setRoiFilter("All");
            setAppreciationFilter("All");
          }
        });
        colorLegendContainer.appendChild(colorBlock);
      });

      this.container.appendChild(colorLegendContainer);

      const dateDiv = document.createElement("div");
      dateDiv.className = "color-palatte-date";
      dateDiv.textContent = formatDate(new Date());
      this.container.appendChild(dateDiv);
    }

    onAdd() {
      return this.container;
    }

    onRemove() {
      this.container.parentNode.removeChild(this.container);
    }
  }

  //    // useEffect to add or remove the toggle control when `isFullWidth` changes
  //    useEffect(() => {
  //     if (!map) return; // Wait for the map to be initialized

  //     const control = new ColorPalette1(isFullWidth, setIsFullWidth);

  //     // Add the control to the map
  //     map.addControl(control, 'bottom-left');

  //     // Cleanup function to remove control when component is unmounted or map is re-rendered
  //     return () => {
  //         if (map) {
  //             map.removeControl(control);
  //         }
  //     };
  // }, [isFullWidth,activeMetric, map]); // This effect will run when `isFullWidth` or `map` changes

  useEffect(() => {
    if (!map) return;

    const controlRef = new ColorPalette1(isFullWidth, setIsFullWidth);
    map.addControl(controlRef, "bottom-left");

    return () => {
      // Only remove if still present
      if (map && controlRef) {
        try {
          map.removeControl(controlRef);
        } catch (e) {
          console.warn("Error removing control:", e);
        }
      }
    };
  }, [isFullWidth, activeMetric, map]);

  // Custom control for the toggle button, to be added/removed dynamically
  class ToggleLayoutControl {
    constructor(isFullWidth, setIsFullWidth) {
      this.container = document.createElement("div");
      this.container.className = "mapboxgl-ctrl mapboxgl-ctrl-group";
      this.container.style.position = "relative";
      this.container.style.cursor = "pointer";

      // Create toggle button
      this.toggleButton = document.createElement("button");
      this.toggleButton.textContent = isFullWidth ? "> Show List" : "< >";
      this.toggleButton.style.fontSize = "14px";
      this.toggleButton.style.padding = "5px 10px";
      this.toggleButton.style.width = isFullWidth ? "120px" : "auto"; // Adjust the width based on state
      this.toggleButton.style.zIndex = 9999;

      // Toggle full-width state when the button is clicked
      this.toggleButton.addEventListener("click", () => {
        setIsFullWidth((prevState) => !prevState);
        this.toggleButton.textContent = isFullWidth ? "<" : ">";
      });

      this.container.appendChild(this.toggleButton);
    }

    onAdd() {
      return this.container;
    }

    onRemove() {
      // Ensure that we are not calling `removeChild` on a null element
      if (this.container && this.container.parentNode) {
        this.container.parentNode.removeChild(this.container);
      }
    }
  }

  //  // useEffect to add or remove the toggle control when `isFullWidth` changes
  //  useEffect(() => {
  //     if (!map) return; // Wait for the map to be initialized

  //     const control = new ToggleLayoutControl(isFullWidth, setIsFullWidth);

  //     // Add the control to the map
  //     //map.addControl(control, 'top-left');

  //     // Cleanup function to remove control when component is unmounted or map is re-rendered
  //     return () => {
  //         if (map) {
  //             map.removeControl(control);
  //         }
  //     };
  // }, [isFullWidth, map]); // This effect will run when `isFullWidth` or `map` changes

  useEffect(() => {
    if (map) {
      map.resize(); // Resize the map to fit the container
    }
  }, [isFullWidth, map]);

  //   const handleSliderChange = (newValue) => {
  //     // console.log("ROIfilter",roiFilter);
  //     // setRoiFilter(newValue);

  //     const roundedValue = Math.round(newValue);
  //   setRoiFilter(roundedValue);
  //   };

  // Update filters based on user selection
  const handleSliderChange = (newValue, filterType) => {
    if (filterType === "roi") {
      setRoiFilter(newValue);
    } else if (filterType === "appreciation") {
      //alert(newValue);
      setAppreciationFilter(newValue);
    } else if (filterType === "score") {
      setScoreFilter(newValue);
    }
  };

  const handlePriceSliderChange = (values) => {
    setMinSales(values[0]); // Update the minimum value
    setMaxSales(values[1]); // Update the maximum value
  };
  function formatNumber(num) {
    if (num >= 1000000) {
      return (num / 1000000).toFixed(1) + "M"; // For millions
    } else if (num >= 1000) {
      return (num / 1000).toFixed(1) + "K"; // For thousands
    } else {
      return num; // No change if it's less than 1000
    }
  }

  // Filter the properties based on the active tab
  //   const filteredPropertyList = activeTab === 'favorites'
  //     ? propertyList.filter((property) => property.favorite) // Only favorites
  //     : propertyList; // All properties
  //     //setPropertyList(propertyList); // Initially, show all properties

  const handleLogout = () => {
    // Remove authToken from localStorage
    localStorage.removeItem("authToken");
    localStorage.removeItem("otp");
    localStorage.removeItem("eula_accepted");
    localStorage.removeItem("isSubscribed");

    // Optional: If you're using a global state (like context or redux), you may want to clear that as well
    // Example with context (if applicable):
    // dispatch({ type: 'LOGOUT' });

    // Redirect user to login page or home page
    window.location.href = "/"; // or use a router if you're using react-router
  };
  const sortProperties = (properties, key, order) => {
    return properties.sort((a, b) => {
      if (order === "asc") {
        return a[key] - b[key];
      } else {
        return b[key] - a[key];
      }
    });
  };
  const getSortArrow = (key) => {
    if (sortKey !== key) return "";
    return sortOrder === "asc" ? "↑" : "↓";
  };

  const sortByROI = (properties) => {
    return [...properties].sort((a, b) => a.score - b.score);
  };

  // Function to change views
  const handleViewChange = (view) => {
    //setPopupHTML(null);
    setCurrentView(view);
    //alert(compareList.length);
    if (view === "list") {
      if (compareList.length > 0 || popupHTML) {
        document.getElementById("detailed_popup").style.display = "block";
      } else {
        document.getElementById("detailed_popup").style.display = "none";
      }
    } else if (view === "split") {
      setIsCompareClicked(false);
      document.getElementById("detailed_popup").style.display = "none";
    } else {
      setIsCompareClicked(false);
      document.getElementById("detailed_popup").style.display = "none";
    }
  };

  useEffect(() => {
    if (map && (currentView === "map" || currentView === "split")) {
      setTimeout(() => {
        map.resize();
      }, 200); // give layout some time to update
    }
  }, [currentView, map]);

  useEffect(() => {
    if (map && (currentView === "map" || currentView === "split")) {
      requestAnimationFrame(() => {
        map.resize();
      });
    }
  }, [currentView, map]);

  const handleDeleteClick = (e, zipcode, currentFav) => {
    e.stopPropagation();
    setZipToRemove({ zipcode, favorite: currentFav });
    setShowConfirmModal(true);
  };

  const handleConfirm = () => {
    if (zipToRemove) {
      toggleFavorite(zipToRemove.zipcode, zipToRemove.favorite);
    }
    setShowConfirmModal(false);
    setZipToRemove(null);
  };

  const handleCancel = () => {
    setShowConfirmModal(false);
    setZipToRemove(null);
  };

  // const filteredList = propertyList.filter(property => !currentStateId || property.state === currentStateId);
  const filteredList = propertyList.filter(
    (property) =>
      (!currentStateId || property.state === currentStateId) &&
      (!currentCity || property.city === currentCity)
  );
  //row click
  const handleRowClick = (zipcode, map, setCurrentPopup, currentView) => {
    setSelectedZipcode(zipcode);
    if(selectedZipcode > 1) {
    setIsCompareClicked(false);
    }

 // ✅ Clear compare list and only keep current row zipcode
 


  // ✅ Reset all checkboxes and only check the clicked one
  if(isCompareClicked){
    
      setCompareList([]); 
  setCheckedItems({ [zipcode]: true });
  }

  // ✅ Clear popup details
  setPopupHTML(null);
    ///compare delection checkbox
    // setCheckedItems({});

    if (currentView === "list") {
      handleLocationSelectList(zipcode, map, setCurrentPopup, currentView);
    } else {
      setCompareList([zipcode]);
      handleLocationSelect(zipcode, map, setCurrentPopup, currentView);
    }
  };
  //compare
  const handleCompare = (zipcode) => {
    setCompareList((prevList) => {
      let updatedList = [...prevList];

        // Always make sure selectedZipcode is the first item
        if (updatedList.length === 0 && selectedZipcode && selectedZipcode !== zipcode) {
          updatedList = [selectedZipcode, zipcode];
        }
         else if (zipcode === selectedZipcode) {
          // Don't allow removing or re-adding the selectedZipcode
          return prevList;
        } else
      if (updatedList.includes(zipcode)) {
        // Remove the zipcode if it's already in the list
        console.log("removed checkbox");
        updatedList = updatedList.filter((item) => item !== zipcode);
        // ✅ hide popup if only 0 or 1 item left
        //   if (updatedList.length <= 1) {
        //     console.log("Hiding popup - less than 2 items left");
        //     document.getElementById("detailed_popup").style.display = "none";
        //     setPopupHTML(null);
        //   }
      } else {
        // Add to list
        updatedList.push(zipcode);
      }

      // Check if the updated list exceeds 4 and show a toast
      if (updatedList.length > 4) {
        toast.error("You can compare up to 4 ZIP codes only.");
        return prevList; // Return the previous list to prevent update
      } else {
        console.log("checkedItems", checkedItems);
        console.log("compareList 2", compareList);
        //check box inclusion
        setCheckedItems((prev) => ({
          ...prev,
          [zipcode]: !prev[zipcode], // toggle check
        }));
      }

      // Show compare details after update
      setTimeout(() => {
        showCompareDetails(updatedList, originalPropertyList);
      }, 0);

      // Show compare details only if 2+ items
      if (updatedList.length === 0) {
        setPopupData(null);
        setIsCompareClicked(!isCompareClicked);
        // if(isCompareClicked===false){
        setCompareList([]);
        console.log("entered");
        document.getElementById("detailed_popup").style.display = "none";
        // setPopupHTML(null);
        handleRowClick(zipcode, map, setCurrentPopup, currentView);
      }

      if (currentView === "list") {
        document.getElementById("detailed_popup").style.display = "block";
      }

      return updatedList;
    });
  };

  const showCompareDetails = (compareList, originalPropertyList) => {
    console.log("compare properties", originalPropertyList);

    const matchedProperties = originalPropertyList.filter((property) =>
      compareList.includes(property.zipcode)
    );

    const selectedZip = selectedZipcode; // Ensure this is globally defined or passed in

    const zipOrder = [
      selectedZip,
      ...compareList.filter((zip) => zip !== selectedZip),
    ];

    const sortedProperties = zipOrder
      .map((zip) => matchedProperties.find((p) => p.zipcode === zip))
      .filter(Boolean); // removes any undefined values if zip not found
    const maxROI = Math.max(...sortedProperties.map((p) => p.roi || 0));
    // const fixedColors = ['#fffbb9', '#8e5ea2', '#3cba9f', '#e8c3b9']; // Fixed color set
    const fixedColors = ["#fdf796", "#8e5ea2", "#EC7357", "#a0a7be"];
    const zipColorMap = {};
    sortedProperties.forEach((p, index) => {
      zipColorMap[p.zipcode] = fixedColors[index % fixedColors.length];
    });
    let popupHTML = `
      
  
      <div class="compareOuter">
            <button class="popup-close-button" id="compare-close-btn" style="
                position: absolute;
                top: 30px;
                right: 10px;
                // background: #fff;
                border: none;
                font-size: 28px;
                cursor: pointer;
                z-index: 10;
                border-radius: 50%;
                width: 32px;
                height: 32px;
                color:#000;
                box-shadow: 0 2px 6px rgba(221, 224, 221, 0.1);
                ">&times;</button>
                <span id="popupToggleArrow"
          style="cursor: pointer; font-size: 20px; position: absolute; top: 10px; right: 50px; z-index: 10;width:18px">
      <img
            src="/assets/expand.svg"
          />
    </span>
        <h4>Compare & Choose</h4> 
       
        <h6>ROI & Appreciation Analysis</h6>
         <div class="popup-content"><canvas id="popupChartBar" width="300" height="300"></canvas></div>
          <h6>Sales Price Analysis</h6>
        <div class="popup-content" style="margin-top: 10px;">
            <canvas id="popupChartList" width="300" height="250"></canvas>
        </div>
        <table class="compare_tbl" border="0" cellpadding="8" cellspacing="0" style="width: 100%; border-collapse: collapse; text-align: center;">
          <thead>
            <tr>
              <th class="metrics">Metric</th>
              ${sortedProperties
                .map(
                  (p) => `
               <th style="background-color: ${
                 zipColorMap[p.zipcode]
               };  font-weight: ${
                    p.zipcode === selectedZip ? "bold" : "normal"
                  };">
                ${p.zipcode}${p.zipcode === selectedZip ? "" : ""}
                </th>`
                )
                .join("")}
            </tr>
          </thead>
          <tbody>
            <tr>
            <td class="metrics">ROI</td>
            ${sortedProperties
              .map((p) => {
                const isMax = p.roi === maxROI;
                const style = `background-color: ${zipColorMap[p.zipcode]};  ${
                  isMax ? "font-weight: bold;" : ""
                }`;
                return `<td style="${style}">${p.roi}%</td>`;
              })
              .join("")}
            </tr>
          <tr>
            <td class="metrics">FLI</td>
            ${sortedProperties
              .map((p, idx) => {
                const color = fixedColors[idx % fixedColors.length];
                return `<td style="background-color: ${color}; ">${p.score}</td>`;
              })
              .join("")}
            </tr>
            <tr>
            <td class="metrics">Appreciation</td>
            ${sortedProperties
              .map((p, idx) => {
                const color = fixedColors[idx % fixedColors.length];
                return `<td style="background-color: ${color}; ">${p.appreciation}%</td>`;
              })
              .join("")}
            </tr>
            <tr>
            <td class="metrics">Sales</td>
            ${sortedProperties
              .map((p, idx) => {
                const color = fixedColors[idx % fixedColors.length];
                return `<td style="background-color: ${color}; ">${formatCurrency(
                  p.sales || 0
                )}</td>`;
              })
              .join("")}
            </tr>
            <tr>
            <td class="metrics">Rent</td>
            ${sortedProperties
              .map((p, idx) => {
                const color = fixedColors[idx % fixedColors.length];
                return `<td style="background-color: ${color}; ">${formatCurrency(
                  p.rent || 0
                )}</td>`;
              })
              .join("")}
            </tr>
            </tbody>      
        </table>
       

        <p style="margin-top: 10px; font-style: italic; color: #555;">
          Selected ZIP (${selectedZip}) is shown as the reference column.
        </p>
      </div>
    `;

    document.getElementById("detailed_popup").innerHTML = popupHTML;
    const outerPopup = document.getElementById("detailed_popup");
    const arrowEl = document.getElementById("popupToggleArrow");

    // Toggle height on click
    arrowEl.addEventListener("click", function () {
      if (outerPopup.style.maxHeight === "100vh") {
        outerPopup.style.maxHeight = "150px"; // collapse
      } else {
        outerPopup.style.maxHeight = "100vh"; // expand
        outerPopup.style.height = "auto";
      }
    });
    setTimeout(() => {
      const closeBtn = document.getElementById("compare-close-btn");
      if (closeBtn) {
        closeBtn.onclick = () => {
          document.getElementById("detailed_popup").style.display = "none";
          setPopupHTML(null);
          setCompareList([]);
        };
      }
    }, 0);
    console.log("compareList", compareList);
    setTimeout(() => {
      const canvas = document.getElementById("popupChartList");
      if (!canvas) return console.error("Chart canvas not found.");

      const url = `https://beta.flowlogic.com/api/compare?zipcodes=${compareList.join(
        ","
      )}`;
      console.log("Fetching compare API:", url);

      fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          // const years = ['2021', '2022', '2023', '2024'];
          const latestYear =
            data?.compare?.[0]?.last_updated_sales_year || 2025;

          // Generate years dynamically from latestYear - 3 to latestYear
          const years = Array.from({ length: 4 }, (_, i) =>
            String(latestYear - 3 + i)
          );

          const fieldMap = {
            [years[0]]: "sales_data_three", // latestYear - 3
            [years[1]]: "sales_data_two", // latestYear - 2
            [years[2]]: "sales_data_one", // latestYear - 1
            [years[3]]: "avg_current_sales", // latestYear
          };

          // const datasets = data.compare.map((entry, index) => ({
          //   label: ` ${entry.zip}`,
          //   data: [
          //     entry.sales_data_three,   // 2021
          //     entry.sales_data_two,     // 2022
          //     entry.sales_data_one,     // 2023
          //     entry.avg_current_sales   // 2024
          //   ],
          //   borderWidth: 2,
          //   fill: false,
          //   tension: 0.3,
          //   borderColor: fixedColors[index % fixedColors.length],  // Assign color based on index
          //   backgroundColor:fixedColors[index % fixedColors.length]
          // }));

          const datasets = data.compare.map((entry, index) => ({
            label: `${entry.zip}`,
            data: years.map((year) => parseFloat(entry[fieldMap[year]]) || 0),
            borderWidth: 2,
            fill: false,
            tension: 0.3,
            borderColor: fixedColors[index % fixedColors.length],
            backgroundColor: fixedColors[index % fixedColors.length],
          }));

          const ctx1 = canvas.getContext("2d");
          new Chart(ctx1, {
            type: "line",
            data: {
              labels: years,
              datasets: datasets,
            },
            options: {
              responsive: true,
              maintainAspectRatio: false,
              plugins: {
                legend: {
                  display: true,
                  labels: {
                    usePointStyle: true, // Use point style instead of line
                    pointStyle: "rectRounded", // Use filled square (can also try 'circle', 'rect', etc.)
                    boxWidth: 15, // Width of legend box
                    boxHeight: 15, // Height of legend box
                    padding: 20,
                  },
                },
                tooltip: {
                  callbacks: {
                    label: function (tooltipItem) {
                      return `${tooltipItem.dataset.label}: ${formatCurrency(
                        tooltipItem.raw
                      )}`;
                    },
                  },
                },
              },
              scales: {
                x: { title: { display: true, text: "Year" } },
                y: {
                  title: { display: true, text: "Sales Price ($)" },
                  ticks: {
                    callback: function (value) {
                      return formatCurrency(value);
                    },
                  },
                },
              },
            },
          });
        })
        .catch((error) => {
          console.error("Failed to fetch sales data for chart:", error);
        });
    }, 100); // Delay for canvas to render

    const zipcodes = sortedProperties.map((p) => p.zipcode);
    const fliData = sortedProperties.map((p) => p.score);
    const roiData = sortedProperties.map((p) => p.roi);
    const apprData = sortedProperties.map((p) => p.appreciation);

    const ctx = document.getElementById("popupChartBar").getContext("2d");

    new Chart(ctx, {
      type: "bar",
      data: {
        labels: zipcodes,
        datasets: [
          {
            label: "ROI (%)",
            data: roiData,
            backgroundColor: "#8e5ea2",
          },
          {
            label: "Appreciation (%)",
            data: apprData,
            backgroundColor: "#3cba9f",
          },
          {
            label: "FLI",
            data: fliData,
            backgroundColor: "#3e95cd",
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: { position: "top" },
          tooltip: {
            callbacks: {
              label: function (tooltipItem) {
                const val = tooltipItem.raw;
                return `${tooltipItem.dataset.label}: ${val}%`;
              },
            },
          },
        },
        scales: {
          x: {
            title: { display: true, text: "ZipCode" },
          },
          y: {
            title: { display: true, text: "Value" },
            beginAtZero: true,
          },
        },
      },
    });
  };

   // Row renderer for react-virtualized
  const rowRenderer = ({ index, key, style }) => {
    const property = filteredList[index];

    if (!property) return null;

    return (
      <tr
        key={key}
        style={style}
        onClick={() =>
          handleRowClick(property.zipcode, map, setCurrentPopup, currentView)
        }
        className={
          searchPincode === property.zipcode
            ? "highlight"
            : compareList.includes(property.zipcode)
            ? "highlight-compare"
            : ""
        }
      >
        {/* Zipcode + compare checkboxes */}
        <td className="zipcodeOuter">
          {currentView === "list" &&
            activeTab === "favorites" &&
            isCompareClicked &&
            (!selectedZipcode &&
            (!compareList || compareList.length === 0 && selectedZipcode === null) ? (
              <input
                type="checkbox"
                checked={compareList.includes(property.zipcode)}
                onClick={(e) => {
                  e.stopPropagation();
                  handleRowClick(property.zipcode);
                }}
                style={{ cursor: "pointer" }}
              />
            ) : selectedZipcode === property.zipcode ? (
              <input
                type="checkbox"
                checked={true}
                onClick={(e) => {
                  e.stopPropagation();
                  handleCompare(property.zipcode);
                }}
                style={{ cursor: "pointer" }}
              />
            ) : (
              <input
                type="checkbox"
                checked={!!checkedItems[property.zipcode]}
                onClick={(e) => {
                  e.stopPropagation();
                  handleCompare(property.zipcode);
                }}
                style={{ cursor: "pointer" }}
              />
            ))}
          &nbsp;{property.zipcode}
        </td>

        {/* Other data cells */}
        <td>{property.roi}%</td>
        <td>{property.appreciation}%</td>
        <td>{property.score}</td>
        <td>{formatCurrency(property.sales)}</td>
        {currentView === "list" && <td>{formatCurrency(property.rent)}</td>}
        <td>{property.city}</td>
        <td>{property.state}</td>

        {/* Favorite / delete buttons */}
        <td>
          {property.favorite ? (
            <button
              onClick={(e) => handleDeleteClick(e, property.zipcode, property.favorite)}
              style={{ background: "none", border: "none", cursor: "pointer" }}
            >
              <img
                src={
                  property.favorite
                    ? "/assets/favorite-G.svg"
                    : "/assets/not_favorite.svg"
                }
                alt={property.favorite ? "Remove Favorite" : "Add Favorite"}
                width="16"
                height="16"
              />
            </button>
          ) : (
            <button
              onClick={(e) => {
                e.stopPropagation();
                toggleFavorite(property.zipcode, property.favorite);
              }}
              style={{ background: "none", border: "none", cursor: "pointer" }}
              title={
                property.favorite ? "Remove from Favorites" : "Add to Favorites"
              }
            >
              <img
                src={
                  property.favorite
                    ? "/assets/favorite-G.svg"
                    : "/assets/not_favorite.svg"
                }
                alt={property.favorite ? "Remove Favorite" : "Add Favorite"}
                width="16"
                height="16"
              />
            </button>
          )}
        </td>
      </tr>
    );
  };

  return (
    <>
      <div
        style={{ display: "flex", flexDirection: "column", height: "100vh" }}
      >
        <Header
          activeTab={activeTab}
          handleTabChange={handleTabChange}
          toggleMenu={toggleMenu}
          isMenuOpen={isMenuOpen}
          handleLogout={handleLogout}
          geocoderContainerRef={geocoderContainerRef}
          showSearch={true}
          showFavorites={true}
          showLinks={true}
          // handleUpgrade={handleUpgrade}
          isSubscribed={isSubscribed}
        />

        <div class="subHeaderOuter">
          {/* <div className="tab-navigation">
                            <Button
                             variant="contained"
                            color="primary filter-button"
                            onClick={() => handleTabChange('all')}
                            className={activeTab === 'all' ? 'active' : ''}
                            >
                            All
                            </Button>
                            <Button
                             variant="contained"
                             color="primary filter-button"
                            onClick={() => handleTabChange('favorites')}
                            className={activeTab === 'favorites' ? 'active' : ''}
                            >
                            Favorites
                            </Button>
                        </div> */}
          {activeTab === "all" ? (
            <div className="filter-wrapper">
              {/* Toggle Icon for Mobile */}
              <div className="mobile-filter-toggle">
                <FilterListIcon
                  onClick={() => setShowMobileFilters(!showMobileFilters)}
                />
                {activeFilterCount > 0 && (
                  <div className="filter-count-badge">{activeFilterCount}</div>
                )}
              </div>
              {(showMobileFilters || window.innerWidth > 768) && (
                <div
                  className={`filterOuter ${showMobileFilters ? "show" : ""}`}
                >
                  {/* <SalesFilterDropdown
                        minSales={minSales}
                        maxSales={maxSales}
                        setSalesFilter={setSalesFilter}
                    /> */}
                  {/* Price Button */}

                  <div class="priceOuter">
                    <Button
                      variant="contained"
                      color="primary filter-button"
                      className={`filter-button ${
                        showPriceFilter ? "filterOuteractive" : ""
                      }`} // Conditionally apply 'filterOuteractive'
                      endIcon={<ArrowDropDownIcon />}
                      onClick={() => {
                        setShowROIFilter(false); // Close the ROI ButtonGroup
                        setShowAppreciationFilter(false); // Close the Appreciation ButtonGroup
                        setShowScoreFilter(false); // Close the Score ButtonGroup
                        setShowPriceFilter(!showPriceFilter);
                      }}
                    >
                      {"Prop. Value"}
                    </Button>
                    {/* Price Range Slider */}
                    {(showPriceFilter || window.innerWidth <= 768) && (
                      <div className="price-filter-container">
                        <ReactSlider
                          className="horizontal-slider"
                          thumbClassName="example-thumb"
                          trackClassName="example-track"
                          value={[minSales, maxSales]} // Bind state values for the slider
                          onChange={handlePriceSliderChange} // Update the state when slider values change
                          min={sliderMinSales} // Set the min value for the slider
                          max={sliderMaxSales} // Set the max value for the slider
                          step={1} // Step value for each movement
                          pearling={true} // Smooth pearling behavior
                          minDistance={10} // Minimum distance between the two thumbs
                          ariaLabel={["Lower thumb", "Upper thumb"]} // Accessibility labels
                          ariaValuetext={(state) =>
                            `Thumb value ${Math.round(state.valueNow)}`
                          } // Accessibility text for thumb value
                          renderThumb={(props, state) => (
                            <div {...props}>
                              {/* // {Math.round(state.valueNow)} Display the value of the thumb */}
                            </div>
                          )}
                        />

                        {/* Optional: Labels for the min and max values */}
                        <div className="slider-labels">
                          <span className="min-label">
                            Min: {formatCurrency(minSales)}
                          </span>
                          <span className="max-label">
                            Max: {formatCurrency(maxSales)}
                          </span>
                        </div>
                      </div>
                    )}
                  </div>
                  <Button
                    variant="contained"
                    color="primary filter-button"
                    className={`filter-button ${
                      showROIFilter ? "filterOuteractive" : ""
                    }`} // Conditionally apply 'filterOuteractive'
                    endIcon={<ArrowDropDownIcon />}
                    onClick={() => {
                      setShowROIFilter(!showROIFilter);
                      setShowAppreciationFilter(false); // Close the Appreciation ButtonGroup
                      setShowScoreFilter(false); // Close the Score ButtonGroup
                      setShowPriceFilter(false);
                    }}
                  >
                    {roiFilter === "All"
                      ? "ROI"
                      : roiFilter !== null
                      ? `ROI - ${roiFilter}%`
                      : "ROI"}{" "}
                    {/* Display "ROI - All" if roiFilter is 0 */}
                    {(showROIFilter || window.innerWidth <= 768) && (
                      <div className="slider-container roi_slider">
                        <ButtonFilter
                          filterType="roi"
                          selectedValue={roiFilter}
                          onClick={handleSliderChange}
                        />
                      </div>
                    )}
                  </Button>

                  <Button
                    variant="contained"
                    color="primary filter-button"
                    endIcon={<ArrowDropDownIcon />}
                    className={`filter-button ${
                      showAppreciationFilter ? "filterOuteractive" : ""
                    }`} // Conditionally apply 'filterOuteractive'
                    onClick={() => {
                      setShowROIFilter(false); // Close the ROI ButtonGroup
                      setShowAppreciationFilter(!showAppreciationFilter);
                      setShowScoreFilter(false); // Close the Score ButtonGroup
                      setShowPriceFilter(false);
                    }}
                  >
                    {appreciationFilter === "All"
                      ? "Appreciation"
                      : appreciationFilter !== null
                      ? `Appreciation - ${appreciationFilter}%`
                      : "Appreciation"}
                    {(showAppreciationFilter || window.innerWidth <= 768) && (
                      <div className="slider-container appr_slider">
                        <ButtonFilter
                          filterType="appreciation"
                          selectedValue={appreciationFilter}
                          onClick={handleSliderChange}
                        />
                      </div>
                    )}
                  </Button>

                  <Button
                    variant="contained"
                    color="primary filter-button"
                    className={`filter-button ${
                      showScoreFilter ? "filterOuteractive" : ""
                    }`} // Conditionally apply 'filterOuteractive'
                    endIcon={<ArrowDropDownIcon />}
                    onClick={() => {
                      setShowROIFilter(false); // Close the ROI ButtonGroup
                      setShowAppreciationFilter(false); // Close the Appreciation ButtonGroup
                      setShowScoreFilter(!showScoreFilter);
                      setShowPriceFilter(false);
                    }}
                  >
                    {/* {scoreFilter === 0 ? 'Score' : scoreFilter !== null ? `Score - ${scoreFilter}` : 'Score'} */}
                    {scoreFilter === "All"
                      ? "FLI"
                      : scoreFilter !== null
                      ? `FLI - ${scoreFilter}`
                      : "FLI"}{" "}
                    {/* Display "ROI - All" if roiFilter is 0 */}
                    {(showScoreFilter || window.innerWidth <= 768) && (
                      <div className="slider-container score_slider">
                        <ButtonFilter
                          filterType="score"
                          selectedValue={scoreFilter}
                          onClick={handleSliderChange}
                        />
                      </div>
                    )}
                  </Button>

                  {(roiFilter !== "All" ||
                    appreciationFilter !== "All" ||
                    scoreFilter !== "All" ||
                    minSales !== sliderMinSales ||
                    maxSales !== sliderMaxSales ||
                    currentView == "list") && (
                    <>
                      <button
                        className="filter-close"
                        onClick={() => setShowMobileFilters(false)}
                      >
                        x
                      </button>
                      <span
                        onClick={() => {
                          // Now show "Clearing filters..." message
                          setIsLoading(true);
                          // document.querySelector(".mapboxgl-ctrl-geocoder--input").value = "";
                          const input = document.querySelector(
                            ".mapboxgl-ctrl-geocoder--input"
                          );
                          if (input) {
                            input.value = "";
                          }

                          if (map.getLayer("state-boundary")) {
                            map.removeLayer("state-boundary");
                          }
                          if (map.getLayer("highlighted-region")) {
                            map.removeLayer("highlighted-region");
                          }
                          if (map.getSource("state-boundary")) {
                            map.removeSource("state-boundary");
                          }
                          setPopupInstance(null);
                          if (popupInstance) {
                            popupInstance.remove();
                            setPopupInstance(null);
                            console.log(
                              "after drag small popup",
                              popupInstance
                            );
                          }
                          closePopup();

                          map.flyTo({
                            // center: [-95.7129, 37.0902],
                            // zoom: 3.5,
                            center: isSubscribed
                              ? [-95.7129, 37.0902]
                              : [-86.2583, 39.8494],
                            zoom: isSubscribed ? 3.5 : 9,
                            essential: true,
                          });
                          // Listen for when flyTo completes
                          map.once("moveend", () => {
                            setShowROIFilter(false);
                            setShowAppreciationFilter(false);
                            setShowScoreFilter(false);
                            setShowPriceFilter(false);
                            setRoiFilter("All");
                            setAppreciationFilter("All");
                            setScoreFilter("All");
                            setMinSales(sliderMinSales);
                            setMaxSales(sliderMaxSales);
                            // Optional delay to show message briefly
                            setTimeout(() => {
                              setIsLoading(false);
                            }, 600);
                          });
                        }}
                        style={{
                          // backgroundColor: '#1976d2',  // Same as Button color
                          color: "#1c8f7d",
                          padding: "8px 16px",
                          borderRadius: "4px",
                          textDecoration: "none",
                          display: "inline-block",
                          fontWeight: 500,
                          cursor: "pointer",
                          userSelect: "none",
                          marginLeft: "8px",
                          fontSize: "14px",
                          textAlign: "center",
                        }}
                      >
                        Clear Filters
                      </span>
                    </>
                  )}
                  {/* {!isSubscribed && (
                            <Button variant="warning" onClick={handleUpgrade}>
                            Upgrade
                            </Button>
                        )} */}

                  {/* Conditionally render each ButtonGroup */}
                </div>
              )}
            </div>
          ) : (
            <div
              class="subHeaderOuter"
              style={{
                display: "flex",
                flexDirection: "row",
                gap: "10px",
              }}
            >
              <div class="filterOuter" style={{ flex: 1 }}>
                <h4>Favorites</h4>
              </div>
              <div
                style={{
                  flex: 6,
                  marginTop: "15px",
                  justifyContent: "flex-end",
                }}
              >
                {/* <div style={{ marginTop: '15px', justifyContent: 'flex-end' }}> */}
                <div className="compareContainer">
                  <Button
                    variant="contained"
                    isCompareClicked
                    // className={`filter-button ${showAppreciationFilter ? 'filterOuteractive' : ''}`} // Conditionally apply 'filterOuteractive'
                    className={`${
                      !isCompareClicked ? "compare-active" : "compare-inactive"
                    }`}
                    onClick={() => {
                      setCurrentView("list");
                      // setIsCompareClicked(true);
                      setIsCompareClicked(!isCompareClicked);
                      // if(isCompareClicked===false){
                      setCompareList([]);
                      //  setSelectedZipcode(null);
                      //  setPopupHTML(null);
                      setCheckedItems({});
                      document.getElementById("detailed_popup").style.display =
                        "none";
                      // document.getElementById("detailed_popup").innerHTML = popupHTML;
                      setPopupHTML(null);

                      // }
                    }}
                  >
                    {"Compare"}
                    {/* {(showAppreciationFilter || window.innerWidth <= 768) && (
                        <div className="slider-container appr_slider">
                            <ButtonFilter filterType="appreciation" selectedValue={appreciationFilter}  onClick={handleSliderChange} />
                        </div>
                    )
                    } */}
                  </Button>
                </div>
              </div>
            </div>
            //  </>
          )}
          <div class="viewMainOuter">
            <div class="viewOuter">
              <div class="views">
                <span>
                  <a
                    href="#"
                    onClick={() => handleViewChange("list")}
                    className={currentView === "list" ? "active" : "inactive"}
                  >
                    {currentView === "list" ? (
                      <img src="/assets/list-flow-active.svg" />
                    ) : (
                      <img src="/assets/list-flow.svg" />
                    )}
                    List
                  </a>
                </span>
                <span class="split">
                  {" "}
                  <a
                    href="#"
                    onClick={() => handleViewChange("split")}
                    className={currentView === "split" ? "active" : "inactive"}
                  >
                    {currentView === "split" ? (
                      <img src="/assets/split-flow-active.svg" />
                    ) : (
                      <img src="/assets/split-flow.svg" />
                    )}
                    Split
                  </a>
                </span>
                <span>
                  <a
                    href="#"
                    onClick={() => handleViewChange("map")}
                    className={currentView === "map" ? "active" : "inactive"}
                  >
                    {currentView === "map" ? (
                      <img src="/assets/map-flow-active.svg" />
                    ) : (
                      <img src="/assets/map-flow.svg" />
                    )}
                    Map
                  </a>
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Main Content (List + Map) */}
        <div className="mainContentOuter">
          <div className="mainOuter">
            <ToastContainer position="top-right" autoClose={3000} />
            {/* Left Side (Property List) */}
            {/* {!isFullWidth && ( */}
            {currentView !== "map" && (
              // <div className="listOuter" style={{
              //     width: currentView === 'list' ? '100%' : '35%',}}>
              // <div
              //     className={`listOuter${currentView === 'list' ? ' full-width' : ''}`}
              // >

              <div
                className="listOuter"
                style={{
                  width:
                    currentView === "list"
                      ? popupHTML
                        ? "70%" // list + popup
                        : "100%" // list only
                      : "38%", // split view
                  // transition: 'width 0.2s ease',
                }}
              >
                {/* <h3 className="property-list-heading"> */}
                {/* <span className="property-heading-text">Results</span> */}

                {/* <span className="property-count">Total No: {filteredList.length}</span> */}
                {/* </h3> */}

                {/* Example Property List */}

                {/* Tab Navigation */}

                <table className="property-table">
                  <thead>
                    <tr>
                      <th>Zipcode</th>
                      <th
                        onClick={() => {
                          if (sortKey === "roi") {
                            setSortOrder(sortOrder === "asc" ? "desc" : "asc");
                          } else {
                            setSortKey("roi");
                            setSortOrder("desc");
                          }
                          setPropertyList((prevList) => [
                            ...sortProperties(
                              [...prevList],
                              "roi",
                              sortKey === "roi"
                                ? sortOrder === "asc"
                                  ? "desc"
                                  : "asc"
                                : "desc"
                            ),
                          ]);
                        }}
                        style={{ cursor: "pointer" }}
                      >
                        ROI {getSortArrow("roi")}
                      </th>
                      <th
                        onClick={() => {
                          if (sortKey === "appreciation") {
                            setSortOrder(sortOrder === "asc" ? "desc" : "asc");
                          } else {
                            setSortKey("appreciation");
                            setSortOrder("desc");
                          }
                          setPropertyList((prevList) => [
                            ...sortProperties(
                              [...prevList],
                              "appreciation",
                              sortKey === "appreciation"
                                ? sortOrder === "asc"
                                  ? "desc"
                                  : "asc"
                                : "desc"
                            ),
                          ]);
                        }}
                        style={{ cursor: "pointer" }}
                      >
                        Appr (%) {getSortArrow("appreciation")}
                      </th>
                      <th
                        onClick={() => {
                          // Toggle sort order if same key is clicked again
                          if (sortKey === "score") {
                            setSortOrder(sortOrder === "asc" ? "desc" : "asc");
                          } else {
                            setSortKey("score");
                            setSortOrder("desc");
                          }
                          // Optionally, update the property list immediately:
                          setPropertyList((prevList) => [
                            ...sortProperties(
                              [...prevList],
                              "score",
                              sortKey === "score"
                                ? sortOrder === "asc"
                                  ? "desc"
                                  : "asc"
                                : "desc"
                            ),
                          ]);
                        }}
                        style={{ cursor: "pointer" }}
                      >
                        FLI {getSortArrow("score")}
                      </th>

                      <th
                        onClick={() => {
                          if (sortKey === "sales") {
                            setSortOrder(sortOrder === "asc" ? "desc" : "asc");
                          } else {
                            setSortKey("sales");
                            setSortOrder("desc");
                          }
                          setPropertyList((prevList) => [
                            ...sortProperties(
                              [...prevList],
                              "sales",
                              sortKey === "sales"
                                ? sortOrder === "asc"
                                  ? "desc"
                                  : "asc"
                                : "desc"
                            ),
                          ]);
                        }}
                        style={{ cursor: "pointer" }}
                      >
                        Prop. Value {getSortArrow("sales")}
                      </th>
                      {currentView === "list" && <th>Rent</th>}
                      <th>City</th>
                      <th>State</th>
                      <th>Action</th>
                      {/* {currentView === 'list' && activeTab === 'favorites' && selectedZipcode && <th className='compare-button'>Compare</th>} */}
                      {/* {currentView === 'list' && activeTab === 'favorites' && isCompareClicked === true && <th className='compare-button'>Compare</th>} */}
                    </tr>
                  </thead>
                  </table>
                  {/* {isLoading ? (
                    <div className="loading-message">Loading...</div> // Show a loading message or spinner
                  ) : (
                    <tbody>
                      {propertyList.length === 0 ? (
                        <tr>
                          <td colSpan="7" className="no-properties">
                            Data loading .. please wait
                          </td>
                        </tr>
                      ) : (
              
                        filteredList.map((property, index) => (
                          <tr
                            key={index}
                            onClick={() =>
                              handleRowClick(
                                property.zipcode,
                                map,
                                setCurrentPopup,
                                currentView
                              )
                            }
                            className={
                              searchPincode === property.zipcode
                                ? "highlight"
                                : compareList.includes(property.zipcode)
                                ? "highlight-compare"
                                : ""
                            }
                          >
                            <td className="zipcodeOuter">
                              {currentView === "list" &&
                                activeTab === "favorites" &&
                                isCompareClicked &&
                                
                                (!selectedZipcode &&   // ✅ Case 1: No selectedZipcode & compareList empty → call row click directly
                                (!compareList || compareList.length === 0 && selectedZipcode===null) ? (
                               
                                         <input
                                    type="checkbox"
                                 
                                    checked={compareList.includes(
                                      property.zipcode
                                    )} // ✅ Selected if already in compare list
                                    onClick={(e) => {    // e.stopPropagation(); // Prevent triggering row click
                                    
                                        handleRowClick(property.zipcode);// Your existing toggle logic
                                    }}
                                    style={{ cursor: "pointer" }}
                                  />
                                ) : // ✅ Case 2: selectedZipcode exists → show checkboxes
                                selectedZipcode === property.zipcode ? (
                                  <input
                                    type="checkbox"
                                 
                                       checked={true}
                                   
                                    onClick={(e) => {
                                      e.stopPropagation(); // Prevent triggering row click
                                      handleCompare(property.zipcode); // Your existing toggle logic
                                    }}
                                    style={{ cursor: "pointer" }}
                                  />
                                ) : (
                                  <input
                                    type="checkbox"
                                    checked={!!checkedItems[property.zipcode]}
                                  
                                    onClick={(e) => {
                                      e.stopPropagation(); // Prevent triggering row click
                                      handleCompare(property.zipcode); // Your existing toggle logic
                                    }}
                                    style={{ cursor: "pointer" }}
                                  />
                                ))}
                              &nbsp;{property.zipcode}
                            </td>
                            <td>{property.roi}%</td>
                            <td>{property.appreciation}%</td>
                            <td>{property.score}</td>
                            <td>{formatCurrency(property.sales)}</td>
                            {currentView === "list" && (
                              <td>{formatCurrency(property.rent)}</td>
                            )}
                            <td>{property.city}</td>
                            <td>{property.state}</td>
                         
                            <td>
                              {property.favorite ? (
                                <button
                                  onClick={(e) =>
                                    handleDeleteClick(
                                      e,
                                      property.zipcode,
                                      property.favorite
                                    )
                                  }
                                  style={{
                                    background: "none",
                                    border: "none",
                                    cursor: "pointer",
                                  }}
                                >
                                  <img
                                    src={
                                      property.favorite
                                        ? "/assets/favorite-G.svg"
                                        : "/assets/not_favorite.svg"
                                    }
                                    alt={
                                      property.favorite
                                        ? "Remove Favorite"
                                        : "Add Favorite"
                                    }
                                    width="16"
                                    height="16"
                                  />
                                </button>
                              ) : (
                                <button
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    toggleFavorite(
                                      property.zipcode,
                                      property.favorite
                                    );
                                  }}
                                  style={{
                                    background: "none",
                                    border: "none",
                                    cursor: "pointer",
                                  }}
                                  title={
                                    property.favorite
                                      ? "Remove from Favorites"
                                      : "Add to Favorites"
                                  }
                                >
                                  <img
                                    src={
                                      property.favorite
                                        ? "/assets/favorite-G.svg"
                                        : "/assets/not_favorite.svg"
                                    }
                                    alt={
                                      property.favorite
                                        ? "Remove Favorite"
                                        : "Add Favorite"
                                    }
                                    width="16"
                                    height="16"
                                  />
                                </button>
                              )}
                            </td>
                     
                        
                          </tr>
                        ))
                      )}
                    </tbody>
                  )} 
                    </table>*/}

 {/* Virtualized tbody */}
      {isLoading ? (
        <div className="loading-message">Loading...</div>
      ) : filteredList.length === 0 ? (
        <div className="no-properties">Data loading .. please wait</div>
      ) : (
        // <div style={{ height: 600 }}> {/* fixed scroll area */}
        //   <AutoSizer>
        //     {({ height, width }) => (
        //       <table className="property-table" style={{ width, borderCollapse: "collapse" }}>
        //         <tbody>
        //           <List
        //             height={height}
        //             rowCount={filteredList.length}
        //             rowHeight={ROW_HEIGHT}
        //             rowRenderer={rowRenderer}
        //             width={width}
        //             overscanRowCount={10}
        //           />
        //         </tbody>
        //       </table>
        //     )}
        //   </AutoSizer>
        // </div>

  <div className="virtualized-body">
      <AutoSizer disableHeight>
    {({ width }) => (
      <List
        height={800} // adjust list height
        width={width}
        rowHeight={30} // must match your row CSS height
        rowCount={filteredList.length}
        overscanRowCount={25}
        rowRenderer={({ index, key, style }) => {
          const property = filteredList[index];
          if (!property) return null;

          return (
            <table
              key={key}
              style={style}
              className="property-table"
            >
              <tbody>
                <tr
                  onClick={() =>
                    handleRowClick(property.zipcode, map, setCurrentPopup, currentView)
                  }
                  className={
                    searchPincode === property.zipcode
                      ? "highlight"
                      : compareList.includes(property.zipcode)
                      ? "highlight-compare"
                      : ""
                  }
                >
                               <td className="zipcodeOuter">
                              {currentView === "list" &&
                                activeTab === "favorites" &&
                                isCompareClicked &&
                                
                                (!selectedZipcode &&   // ✅ Case 1: No selectedZipcode & compareList empty → call row click directly
                                (!compareList || compareList.length === 0 && selectedZipcode===null) ? (
                               
                                         <input
                                    type="checkbox"
                                 
                                    checked={compareList.includes(
                                      property.zipcode
                                    )} // ✅ Selected if already in compare list
                                    onClick={(e) => {    // e.stopPropagation(); // Prevent triggering row click
                                    
                                        handleRowClick(property.zipcode);// Your existing toggle logic
                                    }}
                                    style={{ cursor: "pointer" }}
                                  />
                                ) : // ✅ Case 2: selectedZipcode exists → show checkboxes
                                selectedZipcode === property.zipcode ? (
                                  <input
                                    type="checkbox"
                                 
                                       checked={true}
                                   
                                    onClick={(e) => {
                                      e.stopPropagation(); // Prevent triggering row click
                                      handleCompare(property.zipcode); // Your existing toggle logic
                                    }}
                                    style={{ cursor: "pointer" }}
                                  />
                                ) : (
                                  <input
                                    type="checkbox"
                                    checked={!!checkedItems[property.zipcode]}
                                  
                                    onClick={(e) => {
                                      e.stopPropagation(); // Prevent triggering row click
                                      handleCompare(property.zipcode); // Your existing toggle logic
                                    }}
                                    style={{ cursor: "pointer" }}
                                  />
                                ))}
                              &nbsp;{property.zipcode}
                            </td>
                  <td>{property.roi}%</td>
                  <td>{property.appreciation}%</td>
                  <td>{property.score}</td>
                  <td>{formatCurrency(property.sales)}</td>
                  {currentView === "list" && <td>{formatCurrency(property.rent)}</td>}
                  <td>{property.city}</td>
                  <td>{property.state}</td>
                                        <td>
                              {property.favorite ? (
                                <button
                                  onClick={(e) =>
                                    handleDeleteClick(
                                      e,
                                      property.zipcode,
                                      property.favorite
                                    )
                                  }
                                  style={{
                                    background: "none",
                                    border: "none",
                                    cursor: "pointer",
                                  }}
                                >
                                  <img
                                    src={
                                      property.favorite
                                        ? "/assets/favorite-G.svg"
                                        : "/assets/not_favorite.svg"
                                    }
                                    alt={
                                      property.favorite
                                        ? "Remove Favorite"
                                        : "Add Favorite"
                                    }
                                    width="16"
                                    height="16"
                                  />
                                </button>
                              ) : (
                                <button
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    toggleFavorite(
                                      property.zipcode,
                                      property.favorite
                                    );
                                  }}
                                  style={{
                                    background: "none",
                                    border: "none",
                                    cursor: "pointer",
                                  }}
                                  title={
                                    property.favorite
                                      ? "Remove from Favorites"
                                      : "Add to Favorites"
                                  }
                                >
                                  <img
                                    src={
                                      property.favorite
                                        ? "/assets/favorite-G.svg"
                                        : "/assets/not_favorite.svg"
                                    }
                                    alt={
                                      property.favorite
                                        ? "Remove Favorite"
                                        : "Add Favorite"
                                    }
                                    width="16"
                                    height="16"
                                  />
                                </button>
                              )}
                            </td>
                </tr>
              </tbody>
            </table>
          );
        }}
      />
    )}
  </AutoSizer>
</div>

      )}

      


               
                {/* Confirmation Modal */}
                {showConfirmModal && zipToRemove && (
                  <ConfirmModal
                    visible={showConfirmModal}
                    message={`Are you sure you want to remove <br/><span class="zipHighlight">${zipToRemove.zipcode}</span> zipcode from favorites?`}
                    onConfirm={handleConfirm}
                    onCancel={handleCancel}
                  />
                )}
              </div>
            )}
            {/* {currentView === 'list' &&( */}
            <div
              id="detailed_popup"
              className="popup-sidebar"
              style={{
                width: "30%",
                display: "none",
                // overflow: 'auto',
                // transition: 'width 0.2s ease',
              }}
            >
              <span
                style={{
                  cursor: "pointer",
                  fontSize: "20px",
                  position: "absolute",
                  top: "5px",
                  right: "10px",
                  zIndex: 10,
                }}
                onClick={() => setIsExpanded(!isExpanded)}
              >
                ⬆️
              </span>
            </div>
            {/* )} */}

            {/* Right Side (Map) */}
            {/* {(currentView === 'split' || currentView === 'map') && ( */}
            <div
              id="map"
              style={{
                flex: 1,
                height: "100%",
                position: "relative",
                //  filter: !isSubscribed ? 'grayscale(1) brightness(0.7)' : 'none',
                //  pointerEvents: !isSubscribed ? 'none' : 'auto',
              }}
            ></div>
            {/* {currentView !== 'map' && (
                <div
                                id="detailed_popup"
                                className="popup-sidebar"
                                style={{
                                width: '30%',
                                display:'none',
                               // overflow: 'auto',
                               // transition: 'width 0.2s ease',
                                }}
                                //dangerouslySetInnerHTML={{ __html: popupHTML }}
                            />
                )} */}
            {/* )} */}
          </div>
        </div>
      </div>
      {/* Modal */}
      <div style={{ zIndex: 100 }}>
      
        {/* EULA Modal */}
        <Modal
          isOpen={showEulaModal}
          onRequestClose={() => setShowEulaModal(false)}
          contentLabel="EULA"
          style={{
            content: {
              width: "80%",
              maxWidth: "900px",
              height: "80vh",
              margin: "auto",
              padding: 0,
              display: "flex",
              flexDirection: "column",
              position: "relative",
            },
          }}
        >
          {/* Header with Close button */}
          <div
            style={{
              padding: "10px",
              background: "#f5f5f5",
              borderBottom: "1px solid #ccc",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <h3 style={{ margin: 0 }}>Flowlogic End User License Agreement</h3>
            <button
              onClick={() => setShowEulaModal(false)}
              style={{
                background: "transparent",
                border: "none",
                fontSize: "20px",
                cursor: "pointer",
              }}
            >
              ✕
            </button>
          </div>

          {/* Scrollable HTML Content */}
          <div
            ref={scrollRef}
            onScroll={handleScroll}
            style={{
              flex: 1,
              overflowY: "auto",
              padding: "15px",
              position: "relative",
            }}
            dangerouslySetInnerHTML={{ __html: htmlContent }}
          />

          {/* Agree button — only shows after scroll to bottom */}
          {canAccept && (
            <div
              style={{
                padding: "20px",
                textAlign: "right",
                borderTop: "1px solid #ccc",
              }}
            >
              <button
                // className="btn btn-primary"
                className="btn btn-flow"
                onClick={handleAgree}
              >
                I Agree
              </button>
            </div>
          )}
        </Modal>
      </div>
    </>
  );
};

export default CircleFilter;
